/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useMemo } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
// import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import TSSelect from "components/Forms/TSSelect";
import { Collapse, Modal, ModalBody } from "reactstrap";
import Checkbox from "@material-ui/core/Checkbox";
import { isLineBreak } from "typescript";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import approved from "assets/img/approved.png";
import rejected from "assets/img/rejected.png";
import axios from "utils/httpClient";
import TSUser from "components/Forms/TSUser"; 
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import PeopleIcon from '@material-ui/icons/People';
export const constant = Object.freeze({
  Frequency1: 1,
  Frequency2: 2,
  Frequency3: 3,
  Frequency4: 4
});

// import avatar from "assets/img/faces/marc.jpg";
 
const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    // fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    fontFamily: '"Sarabun", sans-serif',
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const primaryColor = "#af2cc5";

const useStyles = makeStyles(styles);


const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.secondary,
    '&:hover > $content': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus > $content, &$selected > $content': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.grey[400]})`,
      color: 'var(--tree-view-color)',
    },
    '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
      backgroundColor: 'transparent',
    },
  },
  content: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '$expanded > &': {
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
  group: {
    marginLeft: 0,
    '& $content': {
      paddingLeft: theme.spacing(2),
    },
  },
  expanded: {},
  selected: {},
  label: {
    fontWeight: 'inherit',
    color: 'inherit',
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    fontWeight: 'inherit',
    flexGrow: 1,
    fontSize: '1.2rem',
    fontFamily: '"Sarabun", sans-serif',
  },
}));

function StyledTreeItem(props) {
  const classes = useTreeItemStyles();
  const { labelText, labelIcon: LabelIcon, labelInfo, color, bgColor, ...other } = props;

  return (
    <TreeItem
      label={
        <div className={classes.labelRoot}>
          <LabelIcon color="inherit" className={classes.labelIcon} />
          <Typography variant="body2" className={classes.labelText}>
            {labelText}
          </Typography>
          <Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>
        </div>
      }
      style={{
        '--tree-view-color': color,
        '--tree-view-bg-color': bgColor,
      }}
      classes={{
        root: classes.root,
        content: classes.content,
        expanded: classes.expanded,
        selected: classes.selected,
        group: classes.group,
        label: classes.label,
      }}
      {...other}
    />
  );
}

StyledTreeItem.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  labelIcon: PropTypes.elementType.isRequired,
  labelInfo: PropTypes.string,
  labelText: PropTypes.string.isRequired,
};

const useStyles2 = makeStyles({
  // root: {
  //   height: 264,
  //   flexGrow: 1,
  //   maxWidth: 400,
  // },
});


export default function EditKPI() {
  const [showAdd, setShowAdd] = useState(false);
  //const [showAddMonth, setShowAddMonth] = useState(false);
  const [showMonth, setShowMonth] = useState(false);
  const [value, setValue] = useState("");
  const [label, setLabel] = useState("");
  const [add, setAdd] = useState(false);
  const [addMonth, setAddMonth] = useState(false);
  const [clear, setClear] = useState(false);
  const [disable1, setDisable1] = useState(true);
  const [disable2, setDisable2] = useState(true);
  const [disable3, setDisable3] = useState(true);
  const [disable4, setDisable4] = useState(true);
  const [name, setName] = useState("");
  const [objective, setObjective] = useState("");
  const [definition, setDefinition] = useState("");
  const [dataSource, setDataSource] = useState("");
  const [isFetch, setIsFetch] = useState(false);
  const [responsible, setResponsible] = useState("");
  const [informant, setInformant] = useState("");
  const [target, setTarget] = useState("");
  const [data1, setData1] = useState("");
  const [data2, setData2] = useState("");
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [modal4, setModal4] = useState(false);
  const [errMsg, setErrMsg] = useState([]);
  const [modalError, setModalError] = useState(false);
  const [icon, setIcon] = useState("far fa-question-circle");
  const [icon2, setIcon2] = useState("far fa-question-circle");
  const [l1Option, setL1Option] = useState([]);
  const [l2Option, setL2Option] = useState([]);
  const [l3Option, setL3Option] = useState([]);
  const [l4Option, setL4Option] = useState([]);
  const [l5Option, setL5Option] = useState([]);
  const [option1, setOption1] = useState("");
  const [option2, setOption2] = useState("");
  const [option3, setOption3] = useState("");
  const [option4, setOption4] = useState("");
  const [option5, setOption5] = useState("");
  const [oldOption5, setOldOption5] = useState("");
  const [oldOption4, setOldOption4] = useState("");
  const [oldOption3, setOldOption3] = useState("");
  const [oldOption2, setOldOption2] = useState("");
  const [oldOption1, setOldOption1] = useState("");
  const [unitOption, setUnitOption] = useState([]);
  const [typeOption, SetTypeOption] = useState([]);
  const [showOption, SetShowOption] = useState([]);
  const [frequencyOption, SetFrequencyOption] = useState([]);
  const [unit, setUnit] = useState("");
  const [type, setType] = useState("");
  const [show, setShow] = useState("");
  const [frequency, setFrequency] = useState("");
  const [year, setYear] = useState("");
  const [m1Value1, setM1Value1] = useState("");
  const [m2Value1, setM2Value1] = useState("");
  const [m3Value1, setM3Value1] = useState("");
  const [m4Value1, setM4Value1] = useState("");
  const [m5Value1, setM5Value1] = useState("");
  const [m6Value1, setM6Value1] = useState("");
  const [m7Value1, setM7Value1] = useState("");
  const [m8Value1, setM8Value1] = useState("");
  const [m9Value1, setM9Value1] = useState("");
  const [m10Value1, setM10Value1] = useState("");
  const [m11Value1, setM11Value1] = useState("");
  const [m12Value1, setM12Value1] = useState("");
  const [m1Value2, setM1Value2] = useState("");
  const [m2Value2, setM2Value2] = useState("");
  const [m3Value2, setM3Value2] = useState("");
  const [m4Value2, setM4Value2] = useState("");
  const [m5Value2, setM5Value2] = useState("");
  const [m6Value2, setM6Value2] = useState("");
  const [m7Value2, setM7Value2] = useState("");
  const [m8Value2, setM8Value2] = useState("");
  const [m9Value2, setM9Value2] = useState("");
  const [m10Value2, setM10Value2] = useState("");
  const [m11Value2, setM11Value2] = useState("");
  const [m12Value2, setM12Value2] = useState("");
  const [m1Target, setM1Target] = useState("");
  const [m2Target, setM2Target] = useState("");
  const [m3Target, setM3Target] = useState("");
  const [m4Target, setM4Target] = useState("");
  const [m5Target, setM5Target] = useState("");
  const [m6Target, setM6Target] = useState("");
  const [m7Target, setM7Target] = useState("");
  const [m8Target, setM8Target] = useState("");
  const [m9Target, setM9Target] = useState("");
  const [m10Target, setM10Target] = useState("");
  const [m11Target, setM11Target] = useState("");
  const [m12Target, setM12Target] = useState("");
  const [dataId, setDataId] = useState(0);
  const [update, setUpdate] = useState(false);
  const [optionsYear, setOptionsYear] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [modalDelete, setModalDelete] = useState(false);
  const [modalDelete2, setModalDelete2] = useState(false);
  const [dataGroup, setDataGroup] = useState(0);
  const [optionsDataGroup, setOptionsDataGroup] = useState([]);
  const [isAddGroup, setIsAddGroup] = useState(false);
  const [groupName, setGroupName] = useState("");
  const [oldYear, setOldYear] = useState("");
  const [disableGroup, setDisableGroup] = useState(false);
  const [m1Approve, setM1Approve] = useState(false);
  const [m2Approve, setM2Approve] = useState(false);
  const [m3Approve, setM3Approve] = useState(false);
  const [m4Approve, setM4Approve] = useState(false);
  const [m5Approve, setM5Approve] = useState(false);
  const [m6Approve, setM6Approve] = useState(false);
  const [m7Approve, setM7Approve] = useState(false);
  const [m8Approve, setM8Approve] = useState(false);
  const [m9Approve, setM9Approve] = useState(false);
  const [m10Approve, setM10Approve] = useState(false);
  const [m11Approve, setM11Approve] = useState(false);
  const [m12Approve, setM12Approve] = useState(false);
  const [calMonth, setCalMonth] = useState(0);
  const [calYear, setCalYear] = useState(0);
  const [m1Link, setM1Link] = useState("");
  const [m2Link, setM2Link] = useState("");
  const [m3Link, setM3Link] = useState("");
  const [m4Link, setM4Link] = useState("");
  const [m5Link, setM5Link] = useState("");
  const [m6Link, setM6Link] = useState("");
  const [m7Link, setM7Link] = useState("");
  const [m8Link, setM8Link] = useState("");
  const [m9Link, setM9Link] = useState("");
  const [m10Link, setM10Link] = useState("");
  const [m11Link, setM11Link] = useState("");
  const [m12Link, setM12Link] = useState("");
  const [isMobile, setIsMobile] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false)
  const [divide, setDivide]  = useState(0)
  const [responsibleL, setResponsibleL] = useState([]);
  const [isClear, setIsClear] = useState(false);
  const [isResponsible, setIsResponsible] = useState(false);
  let history = useHistory();
  var currentUser = JSON.parse(localStorage.getItem('currentUser'))

  const classes2 = useStyles2();

  const handleClick = (event, name) => {
    if (name === 1) {
      setM1Approve(!m1Approve);
    } else if (name === 2) {
      setM2Approve(!m2Approve);
    } else if (name === 3) {
      setM3Approve(!m3Approve);
    } else if (name === 4) {
      setM4Approve(!m4Approve);
    } else if (name === 5) {
      setM5Approve(!m5Approve);
    } else if (name === 6) {
      setM6Approve(!m6Approve);
    } else if (name === 7) {
      setM7Approve(!m7Approve);
    } else if (name === 8) {
      setM8Approve(!m8Approve);
    } else if (name === 9) {
      setM9Approve(!m9Approve);
    } else if (name === 10) {
      setM10Approve(!m10Approve);
    } else if (name === 11) {
      setM11Approve(!m11Approve);
    } else {
      setM12Approve(!m12Approve);
    }
  };

  function check(arr, el) {
    var a = false;
    arr.forEach((element) => {
      if (element.userName === el) {
        a = true;
      }
    })
    return a;
  }

  const myRef = useRef(null);
  // const optionsYear = [
  //   { value: "2563", label: "2563" },
  //   { value: "2562", label: "2562" },
  //   { value: "2561", label: "2561" },
  //   { value: "2560", label: "2560" },
  //   { value: "2559", label: "2559" },
  //   { value: "2558", label: "2558" }
  // ];
   const optionsDivide = [
    { value: 1, label: "0/0 = 100" },
    { value: 2, label: "0/? = 100" },
    { value: 3, label: "0/0 = 0" },
    { value: 4, label: "0/? = 0" }
  ];

  const handleResize = () => {
    if (window.innerWidth < 960) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  // create an event listener
  useEffect(() => {
    window.addEventListener("resize", handleResize);
  });

  const handleSubmit = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if (name === null || name === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุชื่อตัวชี้วัด"}</li>);
    }

    if (objective === null || objective === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุวัตถุประสงค์"}</li>);
    }

    if (definition === null || definition === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุคำนิยาม"}</li>);
    }

    if (dataSource === null || dataSource === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุแหล่งข้อมูล"}</li>);
    }

    // if (responsible === null || responsible === "") {
    //   cntErr += 1;
    //   errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุผู้รับผิดชอบรายงาน"}</li>);
    // }
    
    if (responsibleL.length < 1) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุผู้รับผิดชอบรายงาน"}</li>);
    }

    if (informant === null || informant === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุผู้ให้ข้อมูล"}</li>);
    }

    // if (target === null || target === "") {
    //   cntErr += 1;
    //   errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุค่าเป้าหมาย"}</li>);
    // }

    if (unit === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาเลือกประเภทของข้อมูล"}</li>);
    }

    if (type === "") {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาเลือกตัวเปรียบเทียบ"}</li>);
    }

    if (show === "") {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>{"กรุณาเลือกรูปแบบการแสดงผลบนหน้า Dashboard"}</li>
      );
    }

    if (frequency === "") {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>{"กรุณาเลือกความถี่ในการปรับปรุงข้อมูล"}</li>
      );
    }

    if (divide === "" && unit === 1) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>{"กรุณาเลือกรูปแบบในการหาร"}</li>
      );
    }

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      if (!showAdd) {
        setModal3(true);
      } else {
        setModal(true);
      }
    }
  };

  const onDelete = e => {
    setModalDelete(true);
  };

  
  const handleEnabled = e => {
    axios.put("/api/v1/enabled/" + dataId)
    .then (
      result => {
        //console.log(result);
        setIsEnabled(result.data.data.isEnabled)
      },
      error => { console.log(error);}
    );
  };

  const handleDelete = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");


    //   method: "DELETE"
    // })
    //   .then(response => response.text())
    //   .then(
    //     result => {
    //       var myBool = String("") === result;
    //       if (!myBool) {
    //         setModalDelete(false);
    //         setIcon("far fa-question-circle");
    //         var errMsg = [];
    //         var cntErr = 0;

    //         cntErr += 1;
    //         errMsg.push(
    //           <li key={cntErr - 1}>{"กรุณาตรวจสอบตัวชี้วัดที่มีอยู่ก่อนลบ"}</li>
    //         );

    //         setErrMsg(errMsg);
    //         setModalError(true);
    //       } else {
    //         setModalDelete(false);
    //         setIcon("far fa-question-circle");
    //         setOption1("");
    //         setOption2("");
    //         setOption3("");
    //         setOption4("");
    //         setOption5("");
    //         setClear(true);
    //         setShowMonth(false);
    //         setAddMonth(false);
    //         setIsOpen(false);
    //         setDisable1(true);
    //         setDisable2(true);
    //         setDisable3(true);
    //         setDisable4(true);
    //       }
    //     },
    //     error => {
    //       alert(error);
    //     }
    //   );

      axios.delete("/api/v1/data/" + dataId)
      .then (
        result => {
        var res = result.data;
        setModalDelete(false);
        setIcon("far fa-question-circle");
        setOption1("");
        setOption2("");
        setOption3("");
        setOption4("");
        setOption5("");
        setClear(true);
        setShowMonth(false);
        setAddMonth(false);
        setIsOpen(false);
        setDisable1(true);
        setDisable2(true);
        setDisable3(true);
        setDisable4(true);
        },
        error => { 
          setModalDelete(false);
          setIcon("far fa-question-circle");
          var errMsg = [];
          var cntErr = 0;
  
          cntErr += 1;
          errMsg.push(
          <li key={cntErr - 1}>
            {error.response.data}
          </li>
          );
  
          setErrMsg(errMsg);
          setModalError(true);
          console.log(error);
        }
      );
  };

  const handleSubmitMonth = evt => {
    evt.preventDefault();
    var cntErr = 0;

    var errMsg = [];

    if (unit === 1 || unit === 3) {
      if (
        (m1Value1 === null ||
          m1Value1 === "" ||
          (m1Value2 === null || m1Value2 === "")) &&
        (m2Value1 === null ||
          m2Value1 === "" ||
          (m2Value2 === null || m2Value2 === "")) &&
        (m3Value1 === null ||
          m3Value1 === "" ||
          (m3Value2 === null || m3Value2 === "")) &&
        (m4Value1 === null ||
          m4Value1 === "" ||
          (m4Value2 === null || m4Value2 === "")) &&
        (m5Value1 === null ||
          m5Value1 === "" ||
          (m5Value2 === null || m5Value2 === "")) &&
        (m6Value1 === null ||
          m6Value1 === "" ||
          (m6Value2 === null || m6Value2 === "")) &&
        (m7Value1 === null ||
          m7Value1 === "" ||
          (m7Value2 === null || m7Value2 === "")) &&
        (m8Value1 === null ||
          m8Value1 === "" ||
          (m8Value2 === null || m8Value2 === "")) &&
        (m9Value1 === null ||
          m9Value1 === "" ||
          (m9Value2 === null || m9Value2 === "")) &&
        (m10Value1 === null ||
          m10Value1 === "" ||
          (m10Value2 === null || m10Value2 === "")) &&
        (m11Value1 === null ||
          m11Value1 === "" ||
          (m11Value2 === null || m11Value2 === "")) &&
        (m12Value1 === null ||
          m12Value1 === "" ||
          (m12Value2 === null || m12Value2 === ""))
      ) {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าอย่างน้อย 1 เดือน"}</li>
        );
      }
      if (m1Value1 !== "" && m1Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนตุลาคมให้ครบ"}</li>
        );
      } else if (m1Value1 === "" && m1Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนตุลาคมให้ครบ"}</li>
        );
      }

      if (m2Value1 !== "" && m2Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนพฤศจิกายนให้ครบ"}</li>
        );
      } else if (m2Value1 === "" && m2Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนพฤศจิกายนให้ครบ"}</li>
        );
      }

      if (m3Value1 !== "" && m3Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนธันวาคมให้ครบ"}</li>
        );
      } else if (m3Value1 === "" && m3Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนธันวาคมให้ครบ"}</li>
        );
      }

      if (m4Value1 !== "" && m4Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมกราคมให้ครบ"}</li>
        );
      } else if (m4Value1 === "" && m4Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมกราคมให้ครบ"}</li>
        );
      }

      if (m5Value1 !== "" && m5Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกุมภาพันธ์ให้ครบ"}</li>
        );
      } else if (m5Value1 === "" && m5Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกุมภาพันธ์ให้ครบ"}</li>
        );
      }

      if (m6Value1 !== "" && m6Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมีนาคมให้ครบ"}</li>
        );
      } else if (m6Value1 === "" && m6Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมีนาคมให้ครบ"}</li>
        );
      }

      if (m7Value1 !== "" && m7Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนเมษายนให้ครบ"}</li>
        );
      } else if (m7Value1 === "" && m7Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนเมษายนให้ครบ"}</li>
        );
      }

      if (m8Value1 !== "" && m8Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนพฤษภาคมให้ครบ"}</li>
        );
      } else if (m8Value1 === "" && m8Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนพฤษภาคมให้ครบ"}</li>
        );
      }

      if (m9Value1 !== "" && m9Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมิถุนายนให้ครบ"}</li>
        );
      } else if (m9Value1 === "" && m9Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมิถุนายนให้ครบ"}</li>
        );
      }

      if (m10Value1 !== "" && m10Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกรกฎาคมให้ครบ"}</li>
        );
      } else if (m10Value1 === "" && m10Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกรกฎาคมให้ครบ"}</li>
        );
      }

      if (m11Value1 !== "" && m11Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนสิงหาคมให้ครบ"}</li>
        );
      } else if (m11Value1 === "" && m11Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนสิงหาคมให้ครบ"}</li>
        );
      }

      if (m12Value1 !== "" && m12Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกันยายนให้ครบ"}</li>
        );
      } else if (m12Value1 === "" && m12Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกันยายนให้ครบ"}</li>
        );
      }
    } else if (unit === 2 || unit === 4) {
      if (
        (m1Value1 === null || m1Value1 === "") &&
        (m2Value1 === null || m2Value1 === "") &&
        (m3Value1 === null || m3Value1 === "") &&
        (m4Value1 === null || m4Value1 === "") &&
        (m5Value1 === null || m5Value1 === "") &&
        (m6Value1 === null || m6Value1 === "") &&
        (m7Value1 === null || m7Value1 === "") &&
        (m9Value1 === null || m8Value1 === "") &&
        (m9Value1 === null || m9Value1 === "") &&
        (m10Value1 === null || m10Value1 === "") &&
        (m11Value1 === null || m11Value1 === "") &&
        (m12Value1 === null || m12Value1 === "")
      ) {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าอย่างน้อย 1 เดือน"}</li>
        );
      }
    }

    if (
      (unit === 1 || unit === 2 || unit === 3 || unit === 4) &&
      (data1 === null || data1 === "")
    ) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุรายการข้อมูล 1"}</li>);
    }

    if ((unit === 1 || unit === 3) && (data2 === null || data2 === "")) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาระบุรายการข้อมูล 2"}</li>);
    }

    if (
      (m1Value1 === null || (m1Value1 === "" && m1Approve)) 
      // && frequency !== 4
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนตุลาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m2Value1 === null ||
      (m2Value1 === "" &&
        m2Approve)
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนพฤศจิกายนให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m3Value1 === null ||
      (m3Value1 === "" &&
        m3Approve) 
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนธันวาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m4Value1 === null ||
      (m4Value1 === "" &&
        m4Approve)
        // &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนมกราคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m5Value1 === null ||
      (m5Value1 === "" &&
        m5Approve) 
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนกุมภาพันธ์ให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m6Value1 === null ||
      (m6Value1 === "" &&
        m6Approve) 
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนมีนาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m7Value1 === null ||
      (m7Value1 === "" && m7Approve) 
      // && frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนเมษายนให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m8Value1 === null ||
      (m8Value1 === "" &&
        m8Approve)
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนพฤษภาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m9Value1 === null ||
      (m9Value1 === "" &&
        m9Approve)
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) 
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนมิถุนายนให้ครบเมื่อมีการ Approve"}
        </li>
      );
    if (
      m10Value1 === null ||
      (m10Value1 === "" &&
        m10Approve)
        // &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนกรกฎาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m11Value1 === null ||
      (m11Value1 === "" &&
        m11Approve)
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนสิงหาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m12Value1 === null ||
      (m12Value1 === "" &&
        m12Approve) 
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนกันยายนให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal2(true);
    }
  };

  const handleSubmitMonthUpdate = evt => {
    evt.preventDefault();
    var cntErr = 0;
    var errMsg = [];

    if (unit === 1 || unit === 3) {
      if (
        (m1Value1 === null ||
          m1Value1 === "" ||
          (m1Value2 === null || m1Value2 === "")) &&
        (m2Value1 === null ||
          m2Value1 === "" ||
          (m2Value2 === null || m2Value2 === "")) &&
        (m3Value1 === null ||
          m3Value1 === "" ||
          (m3Value2 === null || m3Value2 === "")) &&
        (m4Value1 === null ||
          m4Value1 === "" ||
          (m4Value2 === null || m4Value2 === "")) &&
        (m5Value1 === null ||
          m5Value1 === "" ||
          (m5Value2 === null || m5Value2 === "")) &&
        (m6Value1 === null ||
          m6Value1 === "" ||
          (m6Value2 === null || m6Value2 === "")) &&
        (m7Value1 === null ||
          m7Value1 === "" ||
          (m7Value2 === null || m7Value2 === "")) &&
        (m8Value1 === null ||
          m8Value1 === "" ||
          (m8Value2 === null || m8Value2 === "")) &&
        (m9Value1 === null ||
          m9Value1 === "" ||
          (m9Value2 === null || m9Value2 === "")) &&
        (m10Value1 === null ||
          m10Value1 === "" ||
          (m10Value2 === null || m10Value2 === "")) &&
        (m11Value1 === null ||
          m11Value1 === "" ||
          (m11Value2 === null || m11Value2 === "")) &&
        (m12Value1 === null ||
          m12Value1 === "" ||
          (m12Value2 === null || m12Value2 === ""))
      ) {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าอย่างน้อย 1 เดือน"}</li>
        );
      }

      if (m1Value1 !== "" && m1Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนตุลาคมให้ครบ"}</li>
        );
      } else if (m1Value1 === "" && m1Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนตุลาคมให้ครบ"}</li>
        );
      }

      if (m2Value1 !== "" && m2Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนพฤศจิกายนให้ครบ"}</li>
        );
      } else if (m2Value1 === "" && m2Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนพฤศจิกายนให้ครบ"}</li>
        );
      }

      if (m3Value1 !== "" && m3Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนธันวาคมให้ครบ"}</li>
        );
      } else if (m3Value1 === "" && m3Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนธันวาคมให้ครบ"}</li>
        );
      }

      if (m4Value1 !== "" && m4Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมกราคมให้ครบ"}</li>
        );
      } else if (m4Value1 === "" && m4Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมกราคมให้ครบ"}</li>
        );
      }

      if (m5Value1 !== "" && m5Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกุมภาพันธ์ให้ครบ"}</li>
        );
      } else if (m5Value1 === "" && m5Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกุมภาพันธ์ให้ครบ"}</li>
        );
      }

      if (m6Value1 !== "" && m6Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมีนาคมให้ครบ"}</li>
        );
      } else if (m6Value1 === "" && m6Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมีนาคมให้ครบ"}</li>
        );
      }

      if (m7Value1 !== "" && m7Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนเมษายนให้ครบ"}</li>
        );
      } else if (m7Value1 === "" && m7Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนเมษายนให้ครบ"}</li>
        );
      }

      if (m8Value1 !== "" && m8Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนพฤษภาคมให้ครบ"}</li>
        );
      } else if (m8Value1 === "" && m8Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนพฤษภาคมให้ครบ"}</li>
        );
      }

      if (m9Value1 !== "" && m9Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมิถุนายนให้ครบ"}</li>
        );
      } else if (m9Value1 === "" && m9Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนมิถุนายนให้ครบ"}</li>
        );
      }

      if (m10Value1 !== "" && m10Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกรกฎาคมให้ครบ"}</li>
        );
      } else if (m10Value1 === "" && m10Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกรกฎาคมให้ครบ"}</li>
        );
      }

      if (m11Value1 !== "" && m11Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนสิงหาคมให้ครบ"}</li>
        );
      } else if (m11Value1 === "" && m11Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนสิงหาคมให้ครบ"}</li>
        );
      }

      if (m12Value1 !== "" && m12Value2 === "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกันยายนให้ครบ"}</li>
        );
      } else if (m12Value1 === "" && m12Value2 !== "") {
        cntErr += 1;
        errMsg.push(
          <li key={cntErr - 1}>{"กรุณาระบุค่าเดือนกันยายนให้ครบ"}</li>
        );
      }
    }

    if (unit === 2 || unit === 4) {
      if (
        (m1Value1 === null || m1Value1 === "") &&
        (m2Value1 === null || m2Value1 === "") &&
        (m3Value1 === null || m3Value1 === "") &&
        (m4Value1 === null || m4Value1 === "") &&
        (m5Value1 === null || m5Value1 === "") &&
        (m6Value1 === null || m6Value1 === "") &&
        (m7Value1 === null || m7Value1 === "") &&
        (m9Value1 === null || m8Value1 === "") &&
        (m9Value1 === null || m9Value1 === "") &&
        (m10Value1 === null || m10Value1 === "") &&
        (m11Value1 === null || m11Value1 === "") &&
        (m12Value1 === null || m12Value1 === "")
      ) {
          cntErr += 1;
          errMsg.push(
            <li key={cntErr - 1}>{"กรุณาระบุค่าอย่างน้อย 1 เดือน"}</li>
          );
        }
      }

    if (
      (m1Value1 === null || (m1Value1 === "" && m1Approve)) 
      // &&
      // frequency !== 4
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนตุลาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m2Value1 === null ||
      (m2Value1 === "" &&
        m2Approve) 
        // && frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนพฤศจิกายนให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m3Value1 === null ||
      (m3Value1 === "" &&
        m3Approve
       ) 
      //  && frequency !== constant.Frequency2 &&
      //   frequency !== constant.Frequency3 &&
      //   frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนธันวาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m4Value1 === null ||
      (m4Value1 === "" &&
        m4Approve)
        // && frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนมกราคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m5Value1 === null ||
      (m5Value1 === "" &&
        m5Approve) 
        // && frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนกุมภาพันธ์ให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m6Value1 === null ||
      (m6Value1 === "" &&
        m6Approve) 
        // && frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนมีนาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m7Value1 === null ||
      (m7Value1 === "" && m7Approve )
      // && frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนเมษายนให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m8Value1 === null ||
      (m8Value1 === "" &&
        m8Approve) 
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนพฤษภาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m9Value1 === null ||
      (m9Value1 === "" &&
        m9Approve)
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนมิถุนายนให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m10Value1 === null ||
      (m10Value1 === "" &&
        m10Approve)
        // &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนกรกฎาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m11Value1 === null ||
      (m11Value1 === "" &&
        m11Approve)
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนสิงหาคมให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }
    if (
      m12Value1 === null ||
      (m12Value1 === "" &&
        m12Approve)
        // &&
        // frequency !== constant.Frequency2 &&
        // frequency !== constant.Frequency3 &&
        // frequency !== constant.Frequency4)
    ) {
      cntErr += 1;
      errMsg.push(
        <li key={cntErr - 1}>
          {"กรุณาระบุค่าเดือนกันยายนให้ครบเมื่อมีการ Approve"}
        </li>
      );
    }

    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setModal4(true);
    }
  };

  const setBoth = () => {
    setShowAdd(true);
    setClear(true);
    setDataId(0);
    setData1("");
    setData2("");
  };

  const clearM = () => {
    setM1Value1("");
    setM2Value1("");
    setM3Value1("");
    setM4Value1("");
    setM5Value1("");
    setM6Value1("");
    setM7Value1("");
    setM8Value1("");
    setM9Value1("");
    setM10Value1("");
    setM11Value1("");
    setM12Value1("");
    setM1Value2("");
    setM2Value2("");
    setM3Value2("");
    setM4Value2("");
    setM5Value2("");
    setM6Value2("");
    setM7Value2("");
    setM8Value2("");
    setM9Value2("");
    setM10Value2("");
    setM11Value2("");
    setM12Value2("");
    setM1Target("");
    setM2Target("");
    setM3Target("");
    setM4Target("");
    setM5Target("");
    setM6Target("");
    setM7Target("");
    setM8Target("");
    setM9Target("");
    setM10Target("");
    setM11Target("");
    setM12Target("");
    setM1Approve(false);
    setM2Approve(false);
    setM3Approve(false);
    setM4Approve(false);
    setM5Approve(false);
    setM6Approve(false);
    setM7Approve(false);
    setM8Approve(false);
    setM9Approve(false);
    setM10Approve(false);
    setM11Approve(false);
    setM12Approve(false);
    setM1Link("");
    setM2Link("");
    setM3Link("");
    setM4Link("");
    setM5Link("");
    setM6Link("");
    setM7Link("");
    setM8Link("");
    setM9Link("");
    setM10Link("");
    setM11Link("");
    setM12Link("");
    setDataGroup(0);
  };

  const clearM2 = () => {
    setM1Value1("");
    setM2Value1("");
    setM3Value1("");
    setM4Value1("");
    setM5Value1("");
    setM6Value1("");
    setM7Value1("");
    setM8Value1("");
    setM9Value1("");
    setM10Value1("");
    setM11Value1("");
    setM12Value1("");
    setM1Value2("");
    setM2Value2("");
    setM3Value2("");
    setM4Value2("");
    setM5Value2("");
    setM6Value2("");
    setM7Value2("");
    setM8Value2("");
    setM9Value2("");
    setM10Value2("");
    setM11Value2("");
    setM12Value2("");
    setM1Target("");
    setM2Target("");
    setM3Target("");
    setM4Target("");
    setM5Target("");
    setM6Target("");
    setM7Target("");
    setM8Target("");
    setM9Target("");
    setM10Target("");
    setM11Target("");
    setM12Target("");
    setM1Approve("");
    setM2Approve("");
    setM3Approve("");
    setM4Approve("");
    setM5Approve("");
    setM6Approve("");
    setM7Approve("");
    setM8Approve("");
    setM9Approve("");
    setM10Approve("");
    setM11Approve("");
    setM12Approve("");
    setM1Link("");
    setM2Link("");
    setM3Link("");
    setM4Link("");
    setM5Link("");
    setM6Link("");
    setM7Link("");
    setM8Link("");
    setM9Link("");
    setM10Link("");
    setM11Link("");
    setM12Link("");
    // if (calMonth === 1) {
    //   setM1Approve(true);
    // } else if (calMonth === 2) {
    //   setM2Approve(true);
    // } else if (calMonth === 3) {
    //   setM3Approve(true);
    // } else if (calMonth === 4) {
    //   setM4Approve(true);
    // } else if (calMonth === 5) {
    //   setM5Approve(true);
    // } else if (calMonth === 6) {
    //   setM6Approve(true);
    // } else if (calMonth === 7) {
    //   setM7Approve(true);
    // } else if (calMonth === 8) {
    //   setM8Approve(true);
    // } else if (calMonth === 9) {
    //   setM9Approve(true);
    // } else if (calMonth === 10) {
    //   setM10Approve(true);
    // } else if (calMonth === 11) {
    //   setM11Approve(true);
    // } else if (calMonth === 12) {
    //   setM12Approve(true);
    // }
  };

  const checkDefault = e => {
    if (clear && e === undefined) {
      return [{ value: "", label: "" }];
    }
    if (clear && e === 1) {
      return [{ value: "", label: "โปรดเลือกตัวเปรียบเทียบ" }];
    }
    if (clear && e === 2) {
      return [{ value: "", label: "โปรดเลือกประเภทของข้อมูล" }];
    }
    if (clear && e === 3) {
      return [{ value: "", label: "โปรดเลือกรูปแบบการแสดงผลบนหน้า Dashboard" }];
    }
    if (clear && e === 4) {
      return [{ value: "", label: "โปรดเลือกความถี่ในการปรับปรุงข้อมูล" }];
    }
  };

  const defaultUnit = () => {
    if (unit === "") {
      return [{ value: "", label: "โปรดเลือกประเภทของข้อมูล" }];
    } else if (unit === 1) {
      return [{ value: 1, label: "ร้อยละ" }];
    } else if (unit === 2) {
      return [{ value: 2, label: "จำนวน" }];
    } else if (unit === 3) {
      return [{ value: 3, label: "อัตราการเปลี่ยนแปลง" }];
    }
    //Production comment
    // else if (unit === 4) {
    //   return [{ value: 4, label: "ร้อยละ (เพิ่มเอง)" }];
    // }
  };

  const defaultType = () => {
    if (type === "") {
      return [{ value: "", label: "โปรดเลือกตัวเปรียบเทียบ" }];
    } else if (type === 1) {
      return [{ value: 1, label: "มากกว่า" }];
    } else if (type === 2) {
      return [{ value: 2, label: "น้อยกว่า" }];
    } else if (type === 3) {
      return [{ value: 3, label: "เท่ากับ" }];
    } else if (type === 4) {
      return [{ value: 4, label: "มากกว่าหรือเท่ากับ" }];
    } else if (type === 5) {
      return [{ value: 5, label: "น้อยกว่าหรือเท่ากับ" }];
    }
  };

  const defaultShow = () => {
    if (show === "") {
      return [{ value: "", label: "โปรดเลือกรูปแบบการแสดงผลบนหน้า Dashboard" }];
    } else if (show === 1) {
      return [{ value: 1, label: "ค่าเฉลี่ย" }];
    } else if (show === 2) {
      return [{ value: 2, label: "ผลรวม" }];
    }
  };

  const defaultFrequency = () => {
    if (frequency === "") {
      return [{ value: "", label: "โปรดเลือกความถี่ในการปรับปรุงข้อมูล" }];
    } else if (frequency === 1) {
      return [{ value: 1, label: "1 เดือน" }];
    } else if (frequency === 2) {
      return [{ value: 2, label: "3 เดือน" }];
    } else if (frequency === 3) {
      return [{ value: 3, label: "6 เดือน" }];
    } else if (frequency === 4) {
      return [{ value: 4, label: "1 ปี" }];
    }
  };

  const defaultDivide = () => {
    // if (divide === "") {
    //   return [{ value: "", label: "โปรดเลือกรูปแบบการหาร" }];
    // } else 
    if (divide === "" || divide === 1) {
      return [{ value: 1, label: "0/0 = 100" }];
    } else if (divide === 2) {
      return [{ value: 2, label: "0/? = 100" }];
    } else if (divide === 3) {
      return [{ value: 3, label: "0/0 = 0" }];
    } else if (divide === 4) {
      return [{ value: 4, label: "0/? = 0" }];
    }
  };


  const isCheck8 = () => {
    const currentPath = location.pathname.split("/");
    if (l1Option.length !== 0 && currentPath[3] !== undefined) {
      var value = l1Option.filter(p => p.value === option1);
      return [value[0]];
    } else if (
      currentPath[3] === undefined &&
      (option1 === oldOption1 && (option1 === "" && oldOption1 === ""))
    ) {
      return [{ value: "", label: "" }];
    }
  };

  // let isCheck = async function() {
  //   const currentPath = location.pathname.split("/");
  //   if (
  //     option1 !== oldOption1 &&
  //     (currentPath[3] === undefined || currentPath[3] === " ")
  //   ) {
  //     return [{ value: "", label: "" }];
  //   } else {
  //     if (
  //       l2Option.length !== 0 &&
  //       currentPath[3] !== undefined &&
  //       currentPath[3] !== " "
  //     ) {
  //       var value = l2Option.filter(p => p.value === option2);
  //       return [value[0]];
  //     } else if (
  //       currentPath[3] === undefined &&
  //       (option2 === oldOption2 && (option2 === "" && oldOption2 === ""))
  //     ) {
  //       return [{ value: "", label: "" }];
  //     }
  //   }
  // };

  const isCheck = () => {
    const currentPath = location.pathname.split("/");
    if (
      option1 !== oldOption1 &&
      (currentPath[3] === undefined || currentPath[3] === " ")
    ) {
      return [{ value: "", label: "" }];
    } else {
      if (
        l2Option.length !== 0 &&
        currentPath[3] !== undefined &&
        currentPath[3] !== " "
      ) {
        var value = l2Option.filter(p => p.value === option2);
        return [value[0]];
      } else if (
        currentPath[3] === undefined &&
        (option2 === oldOption2 && (option2 === "" && oldOption2 === ""))
      ) {
        return [{ value: "", label: "" }];
      }
    }
  };

  const isCheck2 = () => {
    const currentPath = location.pathname.split("/");
    if (
      option2 !== oldOption2 &&
      (currentPath[3] === undefined || currentPath[3] === " ")
    ) {
      return [{ value: "", label: "" }];
    } else {
      if (
        l3Option.length !== 0 &&
        currentPath[3] !== undefined &&
        currentPath[3] !== " " &&
        (option1 !== 1 && option1 !== 4)
      ) {
        var value = l3Option.filter(p => p.value === Number(currentPath[3]));
        return [value[0]];
      } else if (
        l3Option.length !== 0 &&
        currentPath[3] !== undefined &&
        currentPath[3] !== " " &&
        (option1 === 1 || option1 === 4) &&
        option3 !== ""
      ) {
        var value = l3Option.filter(p => p.value === option3);
        return [value[0]];
      } else if (
        currentPath[3] === undefined &&
        (option3 === oldOption3 && (option3 === "" && oldOption3 === ""))
      ) {
        return [{ value: "", label: "" }];
      }
    }
  };

  const isCheck5 = () => {
    const currentPath = location.pathname.split("/");
    if (
      option3 !== oldOption3 &&
      (currentPath[3] === undefined ||
        (currentPath[3] === " " &&
          (option2 !== oldOption2 ||
            (option3 !== oldOption3 && option3 !== ""))))
    ) {
      return [{ value: "", label: "" }];
    } else {
      if (
        l4Option.length !== 0 &&
        currentPath[3] !== undefined &&
        currentPath[3] !== " " &&
        option1 !== 4
      ) {
        var value = l4Option.filter(p => p.value === currentPath[3]);
        return [value[0]];
      } else if (
        l4Option.length !== 0 &&
        currentPath[3] !== undefined &&
        currentPath[3] !== " " &&
        (option1 === 1 || option1 === 4) &&
        option4 !== ""
      ) {
        var value = l4Option.filter(p => p.value === option4);
        return [value[0]];
      } else if (
        currentPath[3] === undefined &&
        (option4 === oldOption4 && (option4 === "" && oldOption4 === ""))
      ) {
        return [{ value: "", label: "" }];
      }
    }
  };

  const isCheck7 = () => {
    const currentPath = location.pathname.split("/");
    if (
      option4 !== oldOption4 &&
      (currentPath[3] === undefined || currentPath[3] === " ")
    ) {
      return [{ value: "", label: "" }];
    } else {
      if (
        l5Option.length !== 0 &&
        currentPath[3] !== undefined &&
        currentPath[3] !== " "
      ) {
        var value = l5Option.filter(p => p.value === Number(currentPath[3]));
        return [value[0]];
      } else if (
        currentPath[3] === undefined &&
        (option5 === oldOption5 && (option5 === "" && oldOption5 === ""))
      ) {
        return [{ value: "", label: "" }];
      }
    }
  };

  const isCheckDataYear = () => {
    if (year !== oldYear) {
      return [{ value: year, label: year }];
    } else if (oldYear === "") {
      return [optionsYear[0]];
    }
  };

  const isCheckDataGroup = () => {
    if (year !== oldYear) {
      return [{ value: "", label: "" }];
    } else if (oldOption3 !== 0 && optionsDataGroup.length > 0) {
      if (dataGroup === 0 && !isAddGroup && optionsDataGroup !== "") {
        var value = optionsDataGroup[0];
        return [{ value: value.value, label: value.label }];
      } else if (isAddGroup || optionsDataGroup === "") {
        return [{ value: "", label: "" }];
      } else {
        var value = optionsDataGroup.filter(p => p.value === dataGroup);
        return [value[0]];
      }
    } else if (oldOption4 !== 0 && optionsDataGroup.length > 0) {
      if (dataGroup === 0 && !isAddGroup && optionsDataGroup !== "") {
        var value = optionsDataGroup[0];
        return [{ value: value.value, label: value.label }];
      } else if (isAddGroup || optionsDataGroup === "") {
        return [{ value: "", label: "" }];
      } else {
        var value = optionsDataGroup.filter(p => p.value === dataGroup);
        return [value[0]];
      }
    } else if (oldOption5 !== 0 && optionsDataGroup.length > 0) {
      if (dataGroup === 0 && !isAddGroup && optionsDataGroup !== "") {
        var value = optionsDataGroup[0];
        return [{ value: value.value, label: value.label }];
      } else if (isAddGroup || optionsDataGroup === "") {
        return [{ value: "", label: "" }];
      } else {
        var value = optionsDataGroup.filter(p => p.value === dataGroup);
        return [value[0]];
      }
    }
    // else if (option4 !== oldOption4) {
    //   return [{ value: "", label: "" }];
    // } else if (option5 !== oldOption5) {
    //   return [{ value: "", label: "" }];
    // }
  };

  const isCheck3 = () => {
    if (option1 !== 1 && option1 !== 4) {
      if (add || update) {
        axios("/api/v1/group3/" + option2)
          .then(response => response.data)
          .then(
            result => {
              setL3Option(result.data);
              setOldOption2(option2);
            },
            error => {
              console.log(error);
            }
          );
        setAdd(false);
        setUpdate(false);
      }
      return [{ value: value, label: label }];
    }
  };

  const isCheck4 = () => {
    if (option1 !== 4) {
      if (add || update) {
        axios("/api/v1/group4/" + option3)
          .then(response => response.data)
          .then(
            result => {
              setL4Option(result.data);
              setOldOption3(option3);
            },
            error => {
              console.log(error);
            }
          );
        setAdd(false);
        setUpdate(false);
      }
      return [{ value: value, label: label }];
    }
  };

  const isCheck6 = () => {
    if (add || update) {
      axios("/api/v1/group5/" + option4)
        .then(response => response.data)
        .then(
          result => {
            setL5Option(result.data);
            setOldOption4(option4);
          },
          error => {
            console.log(error);
          }
        );
      setAdd(false);
      setUpdate(false);
    }
    if (value !== "" && option5 === "") {
      setOption5(value);
    }
    return [{ value: value, label: label }];
  };

  useEffect(() => {

    //   "/api/v1/group1" /*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/
    // )
    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setL1Option(result.data);
    //     },
    //     error => {
    //       console.log(error);
    //     }
    //   );

    axios("/api/v1/group1")
    .then(
      result => {
        var res = result.data;
        setL1Option(res.data);
      }, error => {console.log(error);}
    );  
  

    axios(
      "/api/v1/unit" /*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/
    )
      .then(response => response.data)
      .then(
        result => {
          setUnitOption(result.data);
        },
        error => {
          console.log(error);
        }
      );

    axios(
      "/api/v1/type" /*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/
    )
      .then(response => response.data)
      .then(
        result => {
          SetTypeOption(result.data);
        },
        error => {
          console.log(error);
        }
      );

    axios(
      "/api/v1/show" /*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/
    )
      .then(response => response.data)
      .then(
        result => {
          SetShowOption(result.data);
        },
        error => {
          console.log(error);
        }
      );

    axios(
      "/api/v1/frequency" /*, { method: 'GET', headers: { 'Content-Type': 'application/json-patch+json' } }*/
    )
      .then(response => response.data)
      .then(
        result => {
          SetFrequencyOption(result.data);
        },
        error => {
          console.log(error);
        }
      );

    axios("/api/v1/year/")
      .then(response => response.data)
      .then(
        result => {
          result.forEach(e => {
            optionsYear.push(e);
          });
        },
        error => {
          console.log(error);
        }
      );
  }, []);

  useEffect(() => {
    if (!add || !update) {
      setValue("");
      setLabel("");
    }
  }, [add, update]);

  useEffect(() => {
    if (clear) {
      setName("");
      setGroupName("");
      setObjective("");
      setDefinition("");
      setDataSource("");
      setResponsible("");
      setInformant("");
      setTarget("");
      setData1("");
      setData2("");
      setDisable1(true);
      setDisable2(true);
      setDisable3(true);
      setDisable4(true);
      setOption1("");
      setOption2("");
      setOption3("");
      setOption4("");
      setOption5("");
      setUnit("");
      setType("");
      setShow("");
      setFrequency("");
      setDivide("");
      setM1Value1("");
      setM2Value1("");
      setM3Value1("");
      setM4Value1("");
      setM5Value1("");
      setM6Value1("");
      setM7Value1("");
      setM8Value1("");
      setM9Value1("");
      setM10Value1("");
      setM11Value1("");
      setM12Value1("");
      setM1Value2("");
      setM2Value2("");
      setM3Value2("");
      setM4Value2("");
      setM5Value2("");
      setM6Value2("");
      setM7Value2("");
      setM8Value2("");
      setM9Value2("");
      setM10Value2("");
      setM11Value2("");
      setM12Value2("");
      setM1Target("");
      setM2Target("");
      setM3Target("");
      setM4Target("");
      setM5Target("");
      setM6Target("");
      setM7Target("");
      setM8Target("");
      setM9Target("");
      setM10Target("");
      setM11Target("");
      setM12Target("");
      setM1Approve(false);
      setM2Approve(false);
      setM3Approve(false);
      setM4Approve(false);
      setM5Approve(false);
      setM6Approve(false);
      setM7Approve(false);
      setM8Approve(false);
      setM9Approve(false);
      setM10Approve(false);
      setM11Approve(false);
      setM12Approve(false);
      setM1Link("");
      setM2Link("");
      setM3Link("");
      setM4Link("");
      setM5Link("");
      setM6Link("");
      setM7Link("");
      setM8Link("");
      setM9Link("");
      setM10Link("");
      setM11Link("");
      setM12Link("");
      setClear(false);
      setShowMonth(false);
      setAddMonth(false);
      setIsOpen(false);
    }
  });

  function timeoutPromise(interval) {
    return new Promise((resolve, reject) => {
      setTimeout(function() {
        resolve("done");
      }, interval);
    });
  }

  // useEffect(() => {
  //   const fetchData = async () => {

  //     if (response.status !== 200) {
  //       console.log("");
  //     } else {
  //       const data = await response.json();
  //       setL2Option(data.data);
  //       setDisable1(false);
  //       setOldOption1(option1);
  //       if (option1 !== oldOption1) {
  //         setL3Option([]);
  //         setDisable2(true);
  //         setDisable3(true);
  //         setDisable4(true);
  //         const currentPath = location.pathname.split("/");
  //         if (currentPath[3] === undefined || currentPath[3] === " ") {
  //           setOption2("");
  //           setOption3("");
  //         }
  //         setName("");
  //         setObjective("");
  //         setDefinition("");
  //         setDataSource("");
  //         setResponsible("");
  //         setInformant("");
  //         setTarget("");
  //         setData1("");
  //         setData2("");
  //         setUnit("");
  //         setType("");
  //         setShow("");
  //         setShowMonth(false);
  //         setIsOpen(false);
  //         clearM();
  //         setOptionsDataGroup("");
  //       }
  //     }
  //   };
  //   fetchData();
  // }, [option1]);

  useEffect(() => {
    if (option1 !== "") {

      //   .then(response => response.json())
      //   .then(
      //     result => {
      //       setL2Option(result.data);
      //       setDisable1(false);
      //       setOldOption1(option1);
      //       if (option1 !== oldOption1) {
      //         setL3Option([]);
      //         setDisable2(true);
      //         setDisable3(true);
      //         setDisable4(true);
      //         const currentPath = location.pathname.split("/");
      //         if (currentPath[3] === undefined || currentPath[3] === " ") {
      //           setOption2("");
      //           setOption3("");
      //         }
      //         setName("");
      //         setObjective("");
      //         setDefinition("");
      //         setDataSource("");
      //         setResponsible("");
      //         setInformant("");
      //         setTarget("");
      //         setData1("");
      //         setData2("");
      //         setUnit("");
      //         setType("");
      //         setShow("");
      //         setShowMonth(false);
      //         setIsOpen(false);
      //         clearM();
      //         setOptionsDataGroup("");
      //       }
      //     },
      //     error => {
      //       console.log(error);
      //     }
      //   );

      axios("/api/v1/group2/" + option1)
      .then(
      result => {
        var res = result.data;
        setL2Option(res.data);
        setDisable1(false);
        setOldOption1(option1);
        if (option1 !== oldOption1) {
          setL3Option([]);
          setDisable2(true);
          setDisable3(true);
          setDisable4(true);
          const currentPath = location.pathname.split("/");
          if (currentPath[3] === undefined || currentPath[3] === " ") {
            setOption2("");
            setOption3("");
          }
          setName("");
          setObjective("");
          setDefinition("");
          setDataSource("");
          setResponsible("");
          setInformant("");
          setTarget("");
          setData1("");
          setData2("");
          setUnit("");
          setType("");
          setShow("");
          setShowMonth(false);
          setIsOpen(false);
          clearM();
          setOptionsDataGroup("");
          }
        }, 
        error => {
          console.log(error);
        }
      );  
    }
  }, [option1]);

  useEffect(() => {
    if (option1 !== 1 && option1 !== 4) {
      if (option2 !== "") {
        axios("/api/v1/group3/" + option2)
          .then(response => response.data)
          .then(
            result => {
              setL3Option(result.data);
              setDisable2(false);
              setOldOption2(option2);
              const currentPath = location.pathname.split("/");
              if (
                (option2 !== oldOption2 && currentPath[3] === undefined) ||
                currentPath[3] === " "
              ) {
                setDisable3(true);
                setDisable4(true);
                setOption3("");
                setOption4("");
                setName("");
                setObjective("");
                setDefinition("");
                setDataSource("");
                setResponsible("");
                setInformant("");
                setTarget("");
                setData1("");
                setData2("");
                setUnit("");
                setType("");
                setShow("");
                setFrequency("");
                setDivide("");
                setShowMonth(false);
                setIsOpen(false);
                clearM();
                setOptionsDataGroup("");
              }

              if (showAdd) {
                setIsOpen(true);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      if (option2 !== "") {
        axios("/api/v1/subGroup3/" + option2)
          .then(response => response.data)
          .then(
            result => {
              setL3Option(result.data);
              setDisable2(false);
              setOldOption2(option2);
              if (option2 !== oldOption2) {
                setDisable3(true);
                setDisable4(true);
                setOption3("");
                const currentPath = location.pathname.split("/");
                if (currentPath[3] === undefined || currentPath[3] === " ") {
                  setOption4("");
                }
                setName("");
                setObjective("");
                setDefinition("");
                setDataSource("");
                setResponsible("");
                setInformant("");
                setTarget("");
                setData1("");
                setData2("");
                setUnit("");
                setType("");
                setShow("");
                setFrequency("");
                setDivide("");
                setShowMonth(false);
                setIsOpen(false);
                clearM();
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }, [option2]);

  useEffect(() => {
    if (option1 !== 1 && option1 !== 4) {
      if (option3 !== "" || option3 !== oldOption3) {
        
        axios("/api/v1/data/" + option3)
          .then(response => response.data)
          .then(
            result2 => {
              setName(result2.data.name);
              setObjective(result2.data.objective);
              setDefinition(result2.data.definition);
              setDataSource(result2.data.dataSource);
              setIsFetch(result2.data.isFetch);
              //setResponsible(result2.data.responsible);
              axios("/api/v1/responsible/" + result2.data.dataId)
              .then(
                result => {
                  var res = result.data;
                    if(res.length > 0){
                      setResponsibleL(res);
                      var a = check(res, currentUser.userName);
                      if(a) {
                        setIsResponsible(true);
                      } else {
                        setIsResponsible(false);
                      }
                    } else {
                      setIsClear(true);
                    }
                  }, error => {
                  setIsClear(true);
                  setIsResponsible(false);
                  console.log(error);
                }
              );  
              setTarget(result2.data.target);
              setInformant(result2.data.informant);
              // if(!isAddGroup){
              //   setData1(result2.data.data1);
              //   setData2(result2.data.data2);
              // }
              setUnit(result2.data.unitId);
              setType(result2.data.typeId);
              setShow(result2.data.showId);
              setFrequency(result2.data.frequencyId);
              setDivide(result2.data.division === null && unit === 1 ? 1 : result2.data.division);
              setOldOption3(option3);
              setShowMonth(true);
              setDataId(result2.data.dataId);
              setIsOpen(true);
              setIsEnabled(result2.data.isEnabled);
              if (!isAddGroup) {
                setCalMonth(result2.data.calMonth);
                setCalYear(result2.data.calYear);
              }
              if (!isAddGroup || (isAddGroup && dataGroup !== 0)) {
                axios(
                  " /api/v1/dataOtherOptions2?dataId=" +
                    result2.data.dataId +
                    "&year=" +
                    year,
                  {
                    method: "GET"
                  }
                )
                  .then(response => response.data)
                  .then(
                    result => {
                      setOptionsDataGroup(result);

                      axios(
                        "/api/v1/data/month?dataId=" +
                          result2.data.dataId +
                          "&year=" +
                          year +
                          "&dataGroup=" +
                          dataGroup,
                        {
                          method: "GET"
                        }
                      )
                        .then(response => response.data)
                        .then(
                          result => {
                            if (result.data.length < 1) {
                              clearM2();
                              setAddMonth(false);
                              axios(
                                "/api/v1/data/name?dataId=" +
                                  result2.data.dataId +
                                  "&dataGroup=" +
                                  dataGroup,
                                {
                                  method: "GET"
                                }
                              )
                                .then(response => response.data)
                                .then(
                                  resultName => {
                                    setData1(
                                      resultName.data.length > 0
                                        ? resultName.data[0].data1
                                        : ""
                                    );
                                    setData2(
                                      resultName.data.length > 0
                                        ? resultName.data[0].data2
                                        : ""
                                    );
                                    setGroupName(
                                      resultName.data.length > 0
                                        ? resultName.data[0].name
                                        : ""
                                    );
                                  },
                                  error => {}
                                );
                            } else {
                              console.log(result);
                              clearM2();
                              if (dataGroup === 0) {
                                setDataGroup(result.data[0].dataGroup);
                              }
                              setIsAddGroup(false);
                              setM1Target(result.data[0] !== undefined ? result.data[0].target : "");
                              setM2Target(result.data[1] !== undefined ? result.data[1].target : "");
                              setM3Target(result.data[2] !== undefined ? result.data[2].target : "");
                              setM4Target(result.data[3] !== undefined ? result.data[3].target : "");
                              setM5Target(result.data[4] !== undefined ? result.data[4].target : "");
                              setM6Target(result.data[5] !== undefined ? result.data[5].target : "");
                              setM7Target(result.data[6] !== undefined ? result.data[6].target : "");
                              setM8Target(result.data[7] !== undefined ? result.data[7].target : "");
                              setM9Target(result.data[8] !== undefined ? result.data[8].target : "");
                              setM10Target(result.data[9] !== undefined ? result.data[9].target : "");
                              setM11Target(result.data[10] !== undefined ? result.data[10].target : "");
                              setM12Target(result.data[11] !== undefined ? result.data[11].target : "");
                              setM1Approve(result.data[0] !== undefined ? result.data[0].isApprove : "");
                              setM2Approve(result.data[1] !== undefined ? result.data[1].isApprove : "");
                              setM3Approve(result.data[2] !== undefined ? result.data[2].isApprove : "");
                              setM4Approve(result.data[3] !== undefined ? result.data[3].isApprove : "");
                              setM5Approve(result.data[4] !== undefined ? result.data[4].isApprove : "");
                              setM6Approve(result.data[5] !== undefined ? result.data[5].isApprove : "");
                              setM7Approve(result.data[6] !== undefined ? result.data[6].isApprove : "");
                              setM8Approve(result.data[7] !== undefined ? result.data[7].isApprove : "");
                              setM9Approve(result.data[8] !== undefined ? result.data[8].isApprove : "");
                              setM10Approve(result.data[9] !== undefined ? result.data[9].isApprove : "");
                              setM11Approve(result.data[10] !== undefined ? result.data[10].isApprove : "");
                              setM12Approve(result.data[11] !== undefined ? result.data[11].isApprove : "");
                              setM1Link(result.data[0] !== undefined ? result.data[0].link : "");
                              setM2Link(result.data[1] !== undefined ? result.data[1].link : "");
                              setM3Link(result.data[2] !== undefined ? result.data[2].link : "");
                              setM4Link(result.data[3] !== undefined ? result.data[3].link : "");
                              setM5Link(result.data[4] !== undefined ? result.data[4].link : "");
                              setM6Link(result.data[5] !== undefined ? result.data[5].link : "");
                              setM7Link(result.data[6] !== undefined ? result.data[6].link : "");
                              setM8Link(result.data[7] !== undefined ? result.data[7].link : "");
                              setM9Link(result.data[8] !== undefined ? result.data[8].link : "");
                              setM10Link(result.data[9] !== undefined ? result.data[9].link : "");
                              setM11Link(result.data[10] !== undefined ? result.data[10].link : "");
                              setM12Link(result.data[11] !== undefined ? result.data[11].link : "");
                              setGroupName(result.data[0].name);
                              if (!isAddGroup) {
                                setData1(result.data[0].data1);
                                setData2(result.data[0].data2);
                              }
                              if (
                                result2.data.unitId === 1 ||
                                result2.data.unitId === 3
                              ) {
                                setM1Value1(result.data[0] !== undefined ? result.data[0].dataValue1 : "");
                                setM1Value2(result.data[0] !== undefined ? result.data[0].dataValue2 : "");
                                setM2Value1(result.data[1] !== undefined ? result.data[1].dataValue1 : "");
                                setM2Value2(result.data[1] !== undefined ? result.data[1].dataValue2 : "");
                                setM3Value1(result.data[2] !== undefined ? result.data[2].dataValue1 : "");
                                setM3Value2(result.data[2] !== undefined ? result.data[2].dataValue2 : "");
                                setM4Value1(result.data[3] !== undefined ? result.data[3].dataValue1 : "");
                                setM4Value2(result.data[3] !== undefined ? result.data[3].dataValue2 : "");
                                setM5Value1(result.data[4] !== undefined ? result.data[4].dataValue1 : "");
                                setM5Value2(result.data[4] !== undefined ? result.data[4].dataValue2 : "");
                                setM6Value1(result.data[5] !== undefined ? result.data[5].dataValue1 : "");
                                setM6Value2(result.data[5] !== undefined ? result.data[5].dataValue2 : "");
                                setM7Value1(result.data[6] !== undefined ? result.data[6].dataValue1 : "");
                                setM7Value2(result.data[6] !== undefined ? result.data[6].dataValue2 : "");
                                setM8Value1(result.data[7] !== undefined ? result.data[7].dataValue1 : "");
                                setM8Value2(result.data[7] !== undefined ? result.data[7].dataValue2 : "");
                                setM9Value1(result.data[8] !== undefined ? result.data[8].dataValue1 : "");
                                setM9Value2(result.data[8] !== undefined ? result.data[8].dataValue2 : "");
                                setM10Value1(result.data[9] !== undefined ? result.data[9].dataValue1 : "");
                                setM10Value2(result.data[9] !== undefined ? result.data[9].dataValue2 : "");
                                setM11Value1(result.data[10] !== undefined ? result.data[10].dataValue1 : "");
                                setM11Value2(result.data[10] !== undefined ? result.data[10].dataValue2 : "");
                                setM12Value1(result.data[11] !== undefined ? result.data[11].dataValue1 : "");
                                setM12Value2(result.data[11] !== undefined ? result.data[11].dataValue2 : "");
                                setAddMonth(true);
                              } else if (
                                result2.data.unitId === 2 ||
                                result2.data.unitId === 4
                              ) {
                                setM1Value1(result.data[0] !== undefined ? result.data[0].dataValue1 : "");
                                setM2Value1(result.data[1] !== undefined ? result.data[1].dataValue1 : "");
                                setM3Value1(result.data[2] !== undefined ? result.data[2].dataValue1 : "");
                                setM4Value1(result.data[3] !== undefined ? result.data[3].dataValue1 : "");
                                setM5Value1(result.data[4] !== undefined ? result.data[4].dataValue1 : "");
                                setM6Value1(result.data[5] !== undefined ? result.data[5].dataValue1 : "");
                                setM7Value1(result.data[6] !== undefined ? result.data[6].dataValue1 : "");
                                setM8Value1(result.data[7] !== undefined ? result.data[7].dataValue1 : "");
                                setM9Value1(result.data[8] !== undefined ? result.data[8].dataValue1 : "");
                                setM10Value1(result.data[9] !== undefined ? result.data[9].dataValue1 : "");
                                setM11Value1(result.data[10] !== undefined ? result.data[10].dataValue1 : "");
                                setM12Value1(result.data[11] !== undefined ? result.data[11].dataValue1 : "");
                                setAddMonth(true);
                              }
                              // var url= document.location.href;
                              // var thisUrl = thisUrl = url.split("/")[0] + '/' + url.split("/")[1] + '/' +
                              //               url.split("/")[2] + '/' + url.split("/")[3] + '/' + url.split("/")[4];
                              //window.history.pushState({}, "", thisUrl);

                              const currentPath = location.pathname.split("/");
                              if (
                                currentPath[3] !== undefined &&
                                currentPath[3] !== " "
                              ) {
                                history.push(" ");
                              }

                              // if (calMonth === 1) {
                              //   setM1Approve(true);
                              // } else if (calMonth === 2) {
                              //   setM2Approve(true);
                              // } else if (calMonth === 3) {
                              //   setM3Approve(true);
                              // } else if (calMonth === 4) {
                              //   setM4Approve(true);
                              // } else if (calMonth === 5) {
                              //   setM5Approve(true);
                              // } else if (calMonth === 6) {
                              //   setM6Approve(true);
                              // } else if (calMonth === 7) {
                              //   setM7Approve(true);
                              // } else if (calMonth === 8) {
                              //   setM8Approve(true);
                              // } else if (calMonth === 9) {
                              //   setM9Approve(true);
                              // } else if (calMonth === 10) {
                              //   setM10Approve(true);
                              // } else if (calMonth === 11) {
                              //   setM11Approve(true);
                              // } else if (calMonth === 12) {
                              //   setM12Approve(true);
                              // }
                            }
                          },
                          error => {
                            //alert(error);
                            setAddMonth(false);
                          }
                        );
                    },
                    error => {}
                  );
              }

              setIsClear(false);
            },
            error => {
              console.log(error);
            }
          );
      }
    } else if (option1 !== 4) {
      const currentPath = location.pathname.split("/");
      if (option3 !== "") {
        axios("/api/v1/group4/" + option3)
          .then(response => response.data)
          .then(
            result => {
              setL4Option(result.data);
              setDisable3(false);
              setOldOption3(option3);
              if (
                (option3 !== oldOption3 && currentPath[3] === undefined) ||
                currentPath[3] === " "
              ) {
                setDisable4(true);
                setOption4("");
                setName("");
                setObjective("");
                setDefinition("");
                setDataSource("");
                setResponsible("");
                setInformant("");
                setTarget("");
                setData1("");
                setData2("");
                setUnit("");
                setType("");
                setShow("");
                setShowMonth(false);
                setIsOpen(false);
                clearM();
              }
              if (showAdd) {
                setIsOpen(true);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      if (option3 !== "") {
        axios("/api/v1/subGroup4/" + option3)
          .then(response => response.data)
          .then(
            result => {
              setL4Option(result.data);
              setDisable3(false);
              setOldOption3(option3);
              if (option3 !== oldOption3) {
                setDisable4(true);
                const currentPath = location.pathname.split("/");
                if (currentPath[3] === undefined || currentPath[3] === " ") {
                  setOption4("");
                }
                setName("");
                setObjective("");
                setDefinition("");
                setDataSource("");
                setResponsible("");
                setInformant("");
                setTarget("");
                setData1("");
                setData2("");
                setUnit("");
                setType("");
                setShow("");
                setFrequency("");
                setDivide("");
                setShowMonth(false);
                setIsOpen(false);
                clearM();
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }, [option3, dataGroup, isAddGroup, year]);

  useEffect(() => {
    if (option1 !== 4) {
      if (option4 !== "" || option4 !== oldOption4) {
        axios("/api/v1/data/" + option4)
          .then(response => response.data)
          .then(
            result2 => {
              setName(result2.data.name);
              setObjective(result2.data.objective);
              setDefinition(result2.data.definition);
              setDataSource(result2.data.dataSource);
              setIsFetch(result2.data.isFetch);
              axios("/api/v1/responsible/" + result2.data.dataId)
              .then(
                result => {
                  var res = result.data;
                    if(res.length > 0){
                      setResponsibleL(res);
                      var a = check(res, currentUser.userName);
                      if(a) {
                        setIsResponsible(true);
                      } else {
                        setIsResponsible(false);
                      }
                    } else {
                      setIsClear(true);
                    }
                  }, error => {
                  setIsClear(true);
                  setIsResponsible(false);
                  console.log(error);
                }
              );  
              //setResponsible(result2.data.responsible);
              setTarget(result2.data.target);
              setInformant(result2.data.informant);
              // setData1(result2.data.data1);
              // setData2(result2.data.data2);
              setUnit(result2.data.unitId);
              setType(result2.data.typeId);
              setShow(result2.data.showId);
              setFrequency(result2.data.frequencyId);
              setDivide(result2.data.division === null && unit === 1 ? 1 : result2.data.division);
              setOldOption3(option3);
              setShowMonth(true);
              setDataId(result2.data.dataId);
              setIsOpen(true);
              setIsEnabled(result2.data.isEnabled);
              if (!isAddGroup) {
                setCalMonth(result2.data.calMonth);
                setCalYear(result2.data.calYear);
              }
              if (!isAddGroup || (isAddGroup && dataGroup !== 0)) {
                axios(
                  " /api/v1/dataOtherOptions2?dataId=" +
                    result2.data.dataId +
                    "&year=" +
                    year,
                  {
                    method: "GET"
                  }
                )
                  .then(response => response.data)
                  .then(
                    result => {
                      setOptionsDataGroup(result);
                      axios(
                        "/api/v1/data/month?dataId=" +
                          result2.data.dataId +
                          "&year=" +
                          year +
                          "&dataGroup=" +
                          dataGroup,
                        {
                          method: "GET"
                        }
                      )
                        .then(response => response.data)
                        .then(
                          result => {
                            if (result.data.length < 1) {
                              clearM2();
                              setAddMonth(false);
                              axios(
                                "/api/v1/data/name?dataId=" +
                                  result2.data.dataId +
                                  "&dataGroup=" +
                                  dataGroup,
                                {
                                  method: "GET"
                                }
                              )
                                .then(response => response.data)
                                .then(
                                  resultName => {
                                    setData1(
                                      resultName.data.length > 0
                                        ? resultName.data[0].data1
                                        : ""
                                    );
                                    setData2(
                                      resultName.data.length > 0
                                        ? resultName.data[0].data2
                                        : ""
                                    );
                                    setGroupName(
                                      resultName.data.length > 0
                                        ? resultName.data[0].name
                                        : ""
                                    );
                                    const currentPath = location.pathname.split(
                                      "/"
                                    );
                                    if (
                                      currentPath[3] !== undefined &&
                                      currentPath[3] !== " "
                                    ) {
                                      history.push(" ");
                                    }
                                  },
                                  error => {}
                                );
                            } else {
                              console.log(result);
                              clearM2();
                              if (dataGroup === 0) {
                                setDataGroup(result.data[0].dataGroup);
                              }
                              setIsAddGroup(false);
                              setM1Target(
                                result.data[0].target !== null
                                  ? result.data[0].target
                                  : ""
                              );
                              setM2Target(
                                result.data[1].target !== null
                                  ? result.data[1].target
                                  : ""
                              );
                              setM3Target(
                                result.data[2].target !== null
                                  ? result.data[2].target
                                  : ""
                              );
                              setM4Target(
                                result.data[3].target !== null
                                  ? result.data[3].target
                                  : ""
                              );
                              setM5Target(
                                result.data[4].target !== null
                                  ? result.data[4].target
                                  : ""
                              );
                              setM6Target(
                                result.data[5].target !== null
                                  ? result.data[5].target
                                  : ""
                              );
                              setM7Target(
                                result.data[6].target !== null
                                  ? result.data[6].target
                                : ""
                              );
                              setM8Target(
                                result.data[7].target !== null
                                  ? result.data[7].target
                                  : ""
                              );
                              setM9Target(
                                result.data[8].target !== null
                                  ? result.data[8].target
                                  : ""
                              );
                              setM10Target(
                                result.data[9].target !== null
                                  ? result.data[9].target
                                  : ""
                              );
                              setM11Target(
                                result.data[10].target !== null
                                  ? result.data[10].target
                                  : ""
                              );
                              setM12Target(
                                result.data[11].target !== null
                                  ? result.data[11].target
                                  : ""
                              );
                              setM1Link(result.data[0].link);
                              setM2Link(result.data[1].link);
                              setM3Link(result.data[2].link);
                              setM4Link(result.data[3].link);
                              setM5Link(result.data[4].link);
                              setM6Link(result.data[5].link);
                              setM7Link(result.data[6].link);
                              setM8Link(result.data[7].link);
                              setM9Link(result.data[8].link);
                              setM10Link(result.data[9].link);
                              setM11Link(result.data[10].link);
                              setM12Link(result.data[11].link);
                              setM1Approve(
                                result.data[0].isApprove !== null
                                  ? result.data[0].isApprove
                                : false
                              );
                              setM2Approve(
                                result.data[1].isApprove !== null
                                  ? result.data[1].isApprove
                                  : false
                              );
                              setM3Approve(
                                result.data[2].isApprove !== null
                                  ? result.data[2].isApprove
                                : false
                              );
                              setM4Approve(
                                result.data[3].isApprove !== null
                                  ? result.data[3].isApprove
                                  : false
                              );
                              setM5Approve(
                                result.data[4].isApprove !== null
                                  ? result.data[4].isApprove
                                  : false
                              );
                              setM6Approve(
                                result.data[5].isApprove !== null
                                  ? result.data[5].isApprove
                                  : false
                              );
                              setM7Approve(
                                result.data[6].isApprove !== null
                                  ? result.data[6].isApprove
                                  : false
                              );
                              setM8Approve(
                                result.data[7].isApprove !== null
                                  ? result.data[7].isApprove
                                  : false
                              );
                              setM9Approve(
                                result.data[8].isApprove !== null
                                  ? result.data[8].isApprove
                                  : false
                              );
                              setM10Approve(
                                result.data[9].isApprove !== null
                                  ? result.data[9].isApprove
                                  : false
                              );
                              setM11Approve(
                                result.data[10].isApprove !== null
                                  ? result.data[10].isApprove
                                  : false
                              );
                              setM12Approve(
                                result.data[11].isApprove !== null
                                  ? result.data[11].isApprove
                                  : false
                              );
                              setGroupName(result.data[0].name);
                              if (!isAddGroup) {
                                setData1(result.data[0].data1);
                                setData2(result.data[0].data2);
                              }
                              if (
                                result2.data.unitId === 1 ||
                                result2.data.unitId === 3
                              ) {
                                setM1Value1(
                                  result.data[0].dataValue1 !== null
                                    ? result.data[0].dataValue1
                                    : ""
                                );
                                setM1Value2(
                                  result.data[0].dataValue2 !== null
                                    ? result.data[0].dataValue2
                                    : ""
                                );
                                setM2Value1(
                                  result.data[1].dataValue1 !== null
                                    ? result.data[1].dataValue1
                                    : ""
                                );
                                setM2Value2(
                                  result.data[1].dataValue2 !== null
                                    ? result.data[1].dataValue2
                                    : ""
                                );
                                setM3Value1(
                                  result.data[2].dataValue1 !== null
                                    ? result.data[2].dataValue1
                                    : ""
                                );
                                setM3Value2(
                                  result.data[2].dataValue2 !== null
                                    ? result.data[2].dataValue2
                                    : ""
                                );
                                setM4Value1(
                                  result.data[3].dataValue1 !== null
                                    ? result.data[3].dataValue1
                                    : ""
                                );
                                setM4Value2(
                                  result.data[3].dataValue2 !== null
                                    ? result.data[3].dataValue2
                                    : ""
                                );
                                setM5Value1(
                                  result.data[4].dataValue1 !== null
                                    ? result.data[4].dataValue1
                                    : ""
                                );
                                setM5Value2(
                                  result.data[4].dataValue2 !== null
                                    ? result.data[4].dataValue2
                                    : ""
                                );
                                setM6Value1(
                                  result.data[5].dataValue1 !== null
                                    ? result.data[5].dataValue1
                                    : ""
                                );
                                setM6Value2(
                                  result.data[5].dataValue2 !== null
                                    ? result.data[5].dataValue2
                                    : ""
                                );
                                setM7Value1(
                                  result.data[6].dataValue1 !== null
                                    ? result.data[6].dataValue1
                                    : ""
                                );
                                setM7Value2(
                                  result.data[6].dataValue2 !== null
                                    ? result.data[6].dataValue2
                                    : ""
                                );
                                setM8Value1(
                                  result.data[7].dataValue1 !== null
                                    ? result.data[7].dataValue1
                                    : ""
                                );
                                setM8Value2(
                                  result.data[7].dataValue2 !== null
                                    ? result.data[7].dataValue2
                                    : ""
                                );
                                setM9Value1(
                                  result.data[8].dataValue1 !== null
                                    ? result.data[8].dataValue1
                                    : ""
                                );
                                setM9Value2(
                                  result.data[8].dataValue2 !== null
                                    ? result.data[8].dataValue2
                                    : ""
                                );
                                setM10Value1(
                                  result.data[9].dataValue1 !== null
                                    ? result.data[9].dataValue1
                                    : ""
                                );
                                setM10Value2(
                                  result.data[9].dataValue2 !== null
                                    ? result.data[9].dataValue2
                                    : ""
                                );
                                setM11Value1(
                                  result.data[10].dataValue1 !== null
                                    ? result.data[10].dataValue1
                                    : ""
                                );
                                setM11Value2(
                                  result.data[10].dataValue2 !== null
                                    ? result.data[10].dataValue2
                                    : ""
                                );
                                setM12Value1(
                                  result.data[11].dataValue1 !== null
                                    ? result.data[11].dataValue1
                                    : ""
                                );
                                setM12Value2(
                                  result.data[11].dataValue2 !== null
                                    ? result.data[11].dataValue2
                                    : ""
                                );
                                setAddMonth(true);
                              } else if (
                                result2.data.unitId === 2 ||
                                result2.data.unitId === 4
                              ) {
                                setM1Value1(
                                  result.data[0].dataValue1 !== null
                                    ? result.data[0].dataValue1
                                    : ""
                                );
                                setM2Value1(
                                  result.data[1].dataValue1 !== null
                                    ? result.data[1].dataValue1
                                    : ""
                                );
                                setM3Value1(
                                  result.data[2].dataValue1 !== null
                                    ? result.data[2].dataValue1
                                    : ""
                                );
                                setM4Value1(
                                  result.data[3].dataValue1 !== null
                                    ? result.data[3].dataValue1
                                    : ""
                                );
                                setM5Value1(
                                  result.data[4].dataValue1 !== null
                                    ? result.data[4].dataValue1
                                    : ""
                                );
                                setM6Value1(
                                  result.data[5].dataValue1 !== null
                                    ? result.data[5].dataValue1
                                    : ""
                                );
                                setM7Value1(
                                  result.data[6].dataValue1 !== null
                                    ? result.data[6].dataValue1
                                    : ""
                                );
                                setM8Value1(
                                  result.data[7].dataValue1 !== null
                                    ? result.data[7].dataValue1
                                    : ""
                                );
                                setM9Value1(
                                  result.data[8].dataValue1 !== null
                                    ? result.data[8].dataValue1
                                    : ""
                                );
                                setM10Value1(
                                  result.data[9].dataValue1 !== null
                                    ? result.data[9].dataValue1
                                    : ""
                                );
                                setM11Value1(
                                  result.data[10].dataValue1 !== null
                                    ? result.data[10].dataValue1
                                    : ""
                                );
                                setM12Value1(
                                  result.data[11].dataValue1 !== null
                                    ? result.data[11].dataValue1
                                    : ""
                                );
                                setAddMonth(true);
                              }

                              const currentPath = location.pathname.split("/");
                              if (
                                currentPath[3] !== undefined &&
                                currentPath[3] !== " "
                              ) {
                                history.push(" ");
                              }

                              // if (calMonth === 1) {
                              //   setM1Approve(true);
                              // } else if (calMonth === 2) {
                              //   setM2Approve(true);
                              // } else if (calMonth === 3) {
                              //   setM3Approve(true);
                              // } else if (calMonth === 4) {
                              //   setM4Approve(true);
                              // } else if (calMonth === 5) {
                              //   setM5Approve(true);
                              // } else if (calMonth === 6) {
                              //   setM6Approve(true);
                              // } else if (calMonth === 7) {
                              //   setM7Approve(true);
                              // } else if (calMonth === 8) {
                              //   setM8Approve(true);
                              // } else if (calMonth === 9) {
                              //   setM9Approve(true);
                              // } else if (calMonth === 10) {
                              //   setM10Approve(true);
                              // } else if (calMonth === 11) {
                              //   setM11Approve(true);
                              // } else if (calMonth === 12) {
                              //   setM12Approve(true);
                              // }
                            }
                          },
                          error => {
                            //alert(error);
                            setAddMonth(false);
                          }
                        );
                    },
                    error => {}
                  );
              }

              setIsClear(false);
            },
            error => {
              console.log(error);
            }
          );
      }
    } else {
      const currentPath = location.pathname.split("/");
      if (option4 !== "") {
        axios("/api/v1/group5/" + option4)
          .then(response => response.data)
          .then(
            result => {
              setL5Option(result.data);
              setDisable4(false);
              setOldOption4(option4);
              if (
                (option4 !== oldOption4 && currentPath[3] === undefined) ||
                currentPath[3] === " "
              ) {
                setOption5("");
                setName("");
                setObjective("");
                setDefinition("");
                setDataSource("");
                setResponsible("");
                setInformant("");
                setTarget("");
                setData1("");
                setData2("");
                setUnit("");
                setType("");
                setShow("");
                setFrequency("");
                setDivide("");
                setShowMonth(false);
                setIsOpen(false);
                clearM();
              }
              if (showAdd) {
                setIsOpen(true);
              }
            },
            error => {
              console.log(error);
            }
          );
      }
    }
  }, [option4, dataGroup, isAddGroup, year]);

  useEffect(() => {
    const fetchData = async () => {
      if (option5 !== "" || option5 !== oldOption5) {
        const response = await axios("/api/v1/data/" + option5, {
          method: "GET"
        });
        if (response.status !== 200) {
          console.log("");
        } else {
          const data = response.data;
          setName(data.data.name);
          setObjective(data.data.objective);
          setDefinition(data.data.definition);
          setDataSource(data.data.dataSource);
          setIsFetch(data.data.isFetch);
          //setResponsible(data.data.responsible);
          axios("/api/v1/responsible/" + data.data.dataId)
          .then(
            result => {
              var res = result.data;
                if(res.length > 0){
                  setResponsibleL(res);
                  var a = check(res, currentUser.userName);
                  if(a) {
                    setIsResponsible(true);
                  } else {
                    setIsResponsible(false);
                  }
                } else {
                  setIsClear(true);
                }
              }, error => {
              setIsClear(true);
              setIsResponsible(false);
              console.log(error);
            }
          );  
          setTarget(data.data.target);
          setInformant(data.data.informant);
          // setData1(data.data.data1);
          // setData2(data.data.data2);
          setUnit(data.data.unitId);
          setType(data.data.typeId);
          setShow(data.data.showId);
          setFrequency(data.data.frequencyId);
          setDivide(data.data.division === null && unit === 1 ? 1 : data.data.division);
          setOldOption3(option3);
          setShowMonth(true);
          setDataId(data.data.dataId);
          setIsOpen(true);
          setIsEnabled(data.data.isEnabled);
          if (!isAddGroup) {
            setCalMonth(data.data.calMonth);
            setCalYear(data.data.calYear);
          }
          if (!isAddGroup || (isAddGroup && dataGroup !== 0)) {
            axios(
              " /api/v1/dataOtherOptions2?dataId=" +
                data.data.dataId +
                "&year=" +
                year,
              {
                method: "GET"
              }
            )
              .then(response => response.data)
              .then(
                result => {
                  setOptionsDataGroup(result);

                  axios(
                    "/api/v1/data/month?dataId=" +
                      data.data.dataId +
                      "&year=" +
                      year +
                      "&dataGroup=" +
                      dataGroup,
                    {
                      method: "GET"
                    }
                  )
                    .then(response => response.data)
                    .then(
                      result => {
                        if (result.data.length < 1) {
                          clearM2();
                          setAddMonth(false);
                          axios(
                            "/api/v1/data/name?dataId=" +
                              data.data.dataId +
                              "&dataGroup=" +
                              dataGroup,
                            {
                              method: "GET"
                            }
                          )
                            .then(response => response.data)
                            .then(
                              resultName => {
                                setData1(
                                  resultName.data.length > 0
                                    ? resultName.data[0].data1
                                    : ""
                                );
                                setData2(
                                  resultName.data.length > 0
                                    ? resultName.data[0].data2
                                    : ""
                                );
                                setGroupName(
                                  resultName.data.length > 0
                                    ? resultName.data[0].name
                                    : ""
                                );
                                const currentPath = location.pathname.split(
                                  "/"
                                );
                                if (
                                  currentPath[3] !== undefined &&
                                  currentPath[3] !== " "
                                ) {
                                  history.push(" ");
                                }
                              },
                              error => {}
                            );
                        } else {
                          console.log(result);
                          clearM2();
                          if (dataGroup === 0) {
                            setDataGroup(result.data[0].dataGroup);
                          }
                          setIsAddGroup(false);
                          setM1Target(
                            result.data[0] !== undefined && result.data[0].target !== null
                              ? result.data[0].target
                              : ""
                          );
                          setM2Target(
                            result.data[1] !== undefined && result.data[1].target !== null
                              ? result.data[1].target
                              : ""
                          );
                          setM3Target(
                            result.data[2] !== undefined && result.data[2].target !== null
                              ? result.data[2].target
                              : ""
                          );
                          setM4Target(
                            result.data[3] !== undefined && result.data[3].target !== null
                              ? result.data[3].target
                              : ""
                          );
                          setM5Target(
                            result.data[4] !== undefined && result.data[4].target !== null
                              ? result.data[4].target
                              : ""
                          );
                          setM6Target(
                            result.data[5] !== undefined && result.data[5].target !== null
                              ? result.data[5].target
                              : ""
                          );
                          setM7Target(
                            result.data[6] !== undefined && result.data[6].target !== null
                              ? result.data[6].target
                              : ""
                          );
                          setM8Target(
                            result.data[7] !== undefined && result.data[7].target !== null
                              ? result.data[7].target
                              : ""
                          );
                          setM9Target(
                            result.data[8] !== undefined && result.data[8].target !== null
                              ? result.data[8].target
                              : ""
                          );
                          setM10Target(
                            result.data[9] !== undefined && result.data[9].target !== null
                              ? result.data[9].target
                              : ""
                          );
                          setM11Target(
                            result.data[10] !== undefined && result.data[10].target !== null
                              ? result.data[10].target
                              : ""
                          );
                          setM12Target(
                            result.data[11] !== undefined && result.data[11].target !== null
                              ? result.data[11].target
                              : ""
                          );
                          setM1Link(
                            result.data.length === 1 ? result.data[0].link : ""
                          );
                          setM2Link(
                            result.data.length === 2 ? result.data[1].link : ""
                          );
                          setM3Link(
                            result.data.length === 3 ? result.data[2].link : ""
                          );
                          setM4Link(
                            result.data.length === 4 ? result.data[3].link : ""
                          );
                          setM5Link(
                            result.data.length === 5 ? result.data[4].link : ""
                          );
                          setM6Link(
                            result.data.length === 6 ? result.data[5].link : ""
                          );
                          setM7Link(
                            result.data.length === 7 ? result.data[6].link : ""
                          );
                          setM8Link(
                            result.data.length === 8 ? result.data[7].link : ""
                          );
                          setM9Link(
                            result.data.length === 9 ? result.data[8].link : ""
                          );
                          setM10Link(
                            result.data.length === 10 ? result.data[9].link : ""
                          );
                          setM11Link(
                            result.data.length === 10
                              ? result.data[10].link
                              : ""
                          );
                          setM12Link(
                            result.data.length === 12
                              ? result.data[11].link
                              : ""
                          );
                          setM1Approve(
                            result.data.length !== 1
                              ? result.data[0] !== undefined && result.data[0].isApprove !== null
                                ? result.data[0].isApprove
                                : false
                              : false
                          );
                          setM2Approve(
                            result.data.length !== 2
                              ? result.data[1] !== undefined && result.data[1].isApprove !== null
                                ? result.data[1].isApprove
                                : false
                              : false
                          );
                          setM3Approve(
                            result.data.length !== 3
                              ? result.data[2] !== undefined && result.data[2].isApprove !== null
                                ? result.data[2].isApprove
                                : false
                              : false
                          );
                          setM4Approve(
                            result.data.length !== 4
                              ? result.data[3] !== undefined && result.data[3].isApprove !== null
                                ? result.data[3].isApprove
                                : false
                              : false
                          );
                          setM5Approve(
                            result.data.length !== 5
                              ? result.data[4] !== undefined && result.data[4].isApprove !== null
                                ? result.data[4].isApprove
                                : false
                              : false
                          );
                          setM6Approve(
                            result.data.length !== 6
                              ? result.data[5] !== undefined && result.data[5].isApprove !== null
                                ? result.data[5].isApprove
                                : false
                              : false
                          );
                          setM7Approve(
                            result.data.length !== 7
                              ? result.data[6] !== undefined && result.data[6].isApprove !== null
                                ? result.data[6].isApprove
                                : false
                              : false
                          );
                          setM8Approve(
                            result.data.length !== 8
                              ? result.data[7] !== undefined && result.data[7].isApprove !== null
                                ? result.data[7].isApprove
                                : false
                              : false
                          );
                          setM9Approve(
                            result.data.length !== 9
                              ? result.data[8] !== undefined && result.data[8].isApprove !== null
                                ? result.data[8].isApprove
                                : false
                              : false
                          );
                          setM10Approve(
                            result.data.length !== 10
                              ? result.data[9] !== undefined && result.data[9].isApprove !== null
                                ? result.data[9].isApprove
                                : false
                              : false
                          );
                          setM11Approve(
                            result.data.length !== 11
                              ? result.data[10] !== undefined && result.data[10].isApprove !== null
                                ? result.data[10].isApprove
                                : false
                              : false
                          );
                          setM12Approve(
                            //result.data.length !== 12
                              //? 
                              result.data[11] !== undefined && result.data[11].isApprove !== null
                                ? result.data[11].isApprove
                                : false
                              //: false
                          );
                          setGroupName(result.data[0].name);
                          if (!isAddGroup) {
                            setData1(result.data[0].data1);
                            setData2(result.data[0].data2);
                          }
                          if (
                            data.data.unitId === 1 ||
                            data.data.unitId === 3
                          ) {
                            setM1Value1(
                              result.data[0].dataValue1 !== null
                                ? result.data[0].dataValue1
                                : ""
                            );
                            setM1Value2(
                              result.data[0].dataValue2 !== null
                                ? result.data[0].dataValue2
                                : ""
                            );
                            setM2Value1(
                              // result.data.length === 2
                              //   ? 
                                result.data[1].dataValue1 !== null
                                  ? result.data[1].dataValue1
                                  : ""
                                // : ""
                            );
                            setM2Value2(
                              //result.data.length === 2
                               // ? 
                                result.data[1].dataValue2 !== null
                                  ? result.data[1].dataValue2
                                  : ""
                               // : ""
                            );
                            setM3Value1(
                              //result.data.length === 3
                              //  ?
                                 result.data[2].dataValue1 !== null
                                  ? result.data[2].dataValue1
                                  : ""
                              //  : ""
                            );
                            setM3Value2(
                             // result.data.length === 3
                               // ? 
                                result.data[2].dataValue2 !== null
                                  ? result.data[2].dataValue2
                                  : ""
                              //  : ""
                            );
                            setM4Value1(
                              // result.data.length === 4
                              //  ? 
                                result.data[3].dataValue1 !== null
                                  ? result.data[3].dataValue1
                                  : ""
                              // : ""
                            );
                            setM4Value2(
                              // result.data.length === 4
                               // ? 
                               result.data[3].dataValue2 !== null
                                  ? result.data[3].dataValue2
                                  : ""
                               // : ""
                            );
                            setM5Value1(
                              // result.data.length === 5
                              //  ? 
                              result.data[4].dataValue1 !== null
                                  ? result.data[4].dataValue1
                                  : ""
                              //  : ""
                            );
                            setM5Value2(
                              // result.data.length === 5
                              //  ? 
                                result.data[4].dataValue2 !== null
                                  ? result.data[4].dataValue2
                                  : ""
                              //  : ""
                            );
                            setM6Value1(
                              // result.data.length === 6
                              //  ? 
                                result.data[5].dataValue1 !== null
                                  ? result.data[5].dataValue1
                                  : ""
                              //  : ""
                            );
                            setM6Value2(
                              //result.data.length === 6
                              //  ? 
                              result.data[5].dataValue2 !== null
                                  ? result.data[5].dataValue2
                                  : ""
                              //  : ""
                            );
                            setM7Value1(
                              // result.data.length === 7
                                // ? 
                                result.data[6].dataValue1 !== null
                                  ? result.data[6].dataValue1
                                  : ""
                              // : ""
                            );
                            setM7Value2(
                              // result.data.length === 7
                              //  ? 
                                result.data[6].dataValue2 !== null
                                  ? result.data[6].dataValue2
                                  : ""
                              //  : ""
                            );
                            setM8Value1(
                              // result.data.length === 8
                              //  ? 
                                result.data[7].dataValue1 !== null
                                  ? result.data[7].dataValue1
                                  : ""
                              //  : ""
                            );
                            setM8Value2(
                              //result.data.length === 8
                              //  ? 
                                result.data[7].dataValue2 !== null
                                  ? result.data[7].dataValue2
                                  : ""
                              //  : ""
                            );
                            setM9Value1(
                              // result.data.length === 9
                              //  ? 
                                result.data[8].dataValue1 !== null
                                  ? result.data[8].dataValue1
                                  : ""
                              //  : ""
                            );
                            setM9Value2(
                              //result.data.length === 9
                              //  ? 
                              result.data[8].dataValue2 !== null
                                  ? result.data[8].dataValue2
                                  : ""
                              //  : ""
                            );
                            setM10Value1(
                              // result.data.length === 10
                              //  ? 
                              result.data[9].dataValue1 !== null
                                  ? result.data[9].dataValue1
                                  : ""
                              //  : ""
                            );
                            setM10Value2(
                              // result.data.length === 10
                              //  ? 
                              result.data[9].dataValue2 !== null
                                  ? result.data[9].dataValue2
                                  : ""
                              //  : ""
                            );
                            setM11Value1(
                              // result.data.length === 11
                              //  ? 
                                result.data[10].dataValue1 !== null
                                  ? result.data[10].dataValue1
                                  : ""
                              //  : ""
                            );
                            setM11Value2(
                              // result.data.length === 11
                              //  ? 
                              result.data[10].dataValue2 !== null
                                  ? result.data[10].dataValue2
                                  : ""
                              //  : ""
                            );
                            setM12Value1(
                              // result.data.length === 12
                              //  ? 
                                result.data[11].dataValue1 !== null
                                  ? result.data[11].dataValue1
                                  : ""
                              //  : ""
                            );
                            setM12Value2(
                              //result.data.length === 12
                              //  ? 
                              result.data[11].dataValue2 !== null
                                  ? result.data[11].dataValue2
                                  : ""
                              //  : ""
                            );
                            setAddMonth(true);
                          } else if (
                            data.data.unitId === 2 ||
                            data.data.unitId === 4
                          ) {
                            setM1Value1(
                              result.data[0] !== undefined && result.data[0].dataValue1 !== null
                                ? result.data[0].dataValue1
                                : ""
                            );
                            setM2Value1(
                              result.data[1] !== undefined && result.data[1].dataValue1 !== null
                                  ? result.data[1].dataValue1
                                  : ""
                            );
                            setM3Value1(
                              result.data[2] !== undefined && result.data[2].dataValue1 !== null
                                  ? result.data[2].dataValue1
                                  : ""
                            );
                            setM4Value1(
                              // result.data.length === 4
                                //  ? 
                                result.data[3] !== undefined && result.data[3].dataValue1 !== null
                                ? result.data[3].dataValue1
                                : ""
                              // : ""
                            );
                            setM5Value1(
                              // result.data.length === 5
                              //   ? 
                                result.data[4] !== undefined && result.data[4].dataValue1 !== null
                                  ? result.data[4].dataValue1
                                  : ""
                                // : ""
                            );
                            setM6Value1(
                              // result.data.length === 6
                                //  ? 
                                result.data[5] !== undefined && result.data[5].dataValue1 !== null
                                  ? result.data[5].dataValue1
                                : ""
                              //  : ""
                            );
                            setM7Value1(
                              // result.data.length === 7
                              //   ? 
                                result.data[6] !== undefined && result.data[6].dataValue1 !== null
                                  ? result.data[6].dataValue1
                                  : ""
                                // : ""
                            );
                            setM8Value1(
                              // result.data.length === 8
                               // ? 
                                result.data[7] !== undefined && result.data[7].dataValue1 !== null
                                  ? result.data[7].dataValue1
                                  : ""
                                // : ""
                            );
                            setM9Value1(
                              // result.data.length === 9
                              //   ? 
                                result.data[8] !== undefined && result.data[8].dataValue1 !== null
                                  ? result.data[8].dataValue1
                                  : ""
                                // : ""
                            );
                            setM10Value1(
                              // result.data.length === 10
                              //   ? 
                                result.data[9] !== undefined && result.data[9].dataValue1 !== null
                                  ? result.data[9].dataValue1
                                  : ""
                                // : ""
                            );
                            setM11Value1(
                              // result.data.length === 11
                              //   ? 
                                result.data[10] !== undefined && result.data[10].dataValue1 !== null
                                  ? result.data[10].dataValue1
                                  : ""
                                // : ""
                            );
                            setM12Value1(
                              // result.data.length === 12
                              //   ? 
                                result.data[11] !== undefined && result.data[11].dataValue1 !== null
                                  ? result.data[11].dataValue1
                                  : ""
                                // : ""
                            );
                            setAddMonth(true);
                          }

                          const currentPath = location.pathname.split("/");
                          if (
                            currentPath[3] !== undefined &&
                            currentPath[3] !== " "
                          ) {
                            history.push(" ");
                          }

                          // if (calMonth === 1) {
                          //   setM1Approve(true);
                          // } else if (calMonth === 2) {
                          //   setM2Approve(true);
                          // } else if (calMonth === 3) {
                          //   setM3Approve(true);
                          // } else if (calMonth === 4) {
                          //   setM4Approve(true);
                          // } else if (calMonth === 5) {
                          //   setM5Approve(true);
                          // } else if (calMonth === 6) {
                          //   setM6Approve(true);
                          // } else if (calMonth === 7) {
                          //   setM7Approve(true);
                          // } else if (calMonth === 8) {
                          //   setM8Approve(true);
                          // } else if (calMonth === 9) {
                          //   setM9Approve(true);
                          // } else if (calMonth === 10) {
                          //   setM10Approve(true);
                          // } else if (calMonth === 11) {
                          //   setM11Approve(true);
                          // } else if (calMonth === 12) {
                          //   setM12Approve(true);
                          // }
                        }
                      },
                      error => {
                        //alert(error);
                        setAddMonth(false);
                      }
                    );
                },
                error => {}
              );
          }
        }
      }

      setIsClear(false);
    };
    fetchData().catch(error => console.error(error));
  }, [option5, dataGroup, isAddGroup, year]);

  useEffect(() => {

    //   method: "GET"
    // })
    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       console.log(result);
    //       setM1Target(result.data[0].target !== null ? result.data[0].target : "");
    //       setM2Target(result.data[1].target !== null ? result.data[1].target : "");
    //       setM3Target(result.data[2].target !== null ? result.data[2].target : "");
    //       setM4Target(result.data[3].target !== null ? result.data[3].target : "");
    //       setM5Target(result.data[4].target !== null ? result.data[4].target : "");
    //       setM6Target(result.data[5].target !== null ? result.data[5].target : "");
    //       setM7Target(result.data[6].target !== null ? result.data[6].target : "");
    //       setM8Target(result.data[7].target !== null ? result.data[7].target : "");
    //       setM9Target(result.data[8].target !== null ? result.data[8].target : "");
    //       setM10Target(result.data[9].target !== null ? result.data[9].target : "");
    //       setM11Target(result.data[10].target !== null ? result.data[10].target : "");
    //       setM12Target(result.data[11].target !== null ? result.data[11].target : "");
    //       if (unit === 1 || unit === 3) {
    //         setM1Value1(result.data[0].dataValue1 !== null ? result.data[0].dataValue1 : "");
    //         setM1Value2(result.data[0].dataValue2 !== null ? result.data[0].dataValue2 : "");
    //         setM2Value1(result.data[1].dataValue1 !== null ? result.data[1].dataValue1 : "");
    //         setM2Value2(result.data[1].dataValue2 !== null ? result.data[1].dataValue2 : "");
    //         setM3Value1(result.data[2].dataValue1 !== null ? result.data[2].dataValue1 : "");
    //         setM3Value2(result.data[2].dataValue2 !== null ? result.data[2].dataValue2 : "");
    //         setM4Value1(result.data[3].dataValue1 !== null ? result.data[3].dataValue1 : "");
    //         setM4Value2(result.data[3].dataValue2 !== null ? result.data[3].dataValue2 : "");
    //         setM5Value1(result.data[4].dataValue1 !== null ? result.data[4].dataValue1 : "");
    //         setM5Value2(result.data[4].dataValue2 !== null ? result.data[4].dataValue2 : "");
    //         setM6Value1(result.data[5].dataValue1 !== null ? result.data[5].dataValue1 : "");
    //         setM6Value2(result.data[5].dataValue2 !== null ? result.data[5].dataValue2 : "");
    //         setM7Value1(result.data[6].dataValue1 !== null ? result.data[6].dataValue1 : "");
    //         setM7Value2(result.data[6].dataValue2 !== null ? result.data[6].dataValue2 : "");
    //         setM8Value1(result.data[7].dataValue1 !== null ? result.data[7].dataValue1 : "");
    //         setM8Value2(result.data[7].dataValue2 !== null ? result.data[7].dataValue2 : "");
    //         setM9Value1(result.data[8].dataValue1 !== null ? result.data[8].dataValue1 : "");
    //         setM9Value2(result.data[8].dataValue2 !== null ? result.data[8].dataValue2 : "");
    //         setM10Value1(result.data[9].dataValue1 !== null ? result.data[9].dataValue1 : "");
    //         setM10Value2(result.data[9].dataValue2 !== null ? result.data[9].dataValue2 : "");
    //         setM11Value1(result.data[10].dataValue1 !== null ? result.data[10].dataValue1 : "");
    //         setM11Value2(result.data[10].dataValue2 !== null ? result.data[10].dataValue2 : "");
    //         setM12Value1(result.data[11].dataValue1 !== null ? result.data[11].dataValue1 : "");
    //         setM12Value2(result.data[11].dataValue2 !== null ? result.data[11].dataValue2 : "");
    //         setAddMonth(true);
    //       } else if (unit === 2 || unit === 4) {
    //         setM1Value1(result.data[0].dataValue1 !== null ? result.data[0].dataValue1 : "");
    //         setM2Value1(result.data[1].dataValue1 !== null ? result.data[1].dataValue1 : "");
    //         setM3Value1(result.data[2].dataValue1 !== null ? result.data[2].dataValue1 : "");
    //         setM4Value1(result.data[3].dataValue1 !== null ? result.data[3].dataValue1 : "");
    //         setM5Value1(result.data[4].dataValue1 !== null ? result.data[4].dataValue1 : "");
    //         setM6Value1(result.data[5].dataValue1 !== null ? result.data[5].dataValue1 : "");
    //         setM7Value1(result.data[6].dataValue1 !== null ? result.data[6].dataValue1 : "");
    //         setM8Value1(result.data[7].dataValue1 !== null ? result.data[7].dataValue1 : "");
    //         setM9Value1(result.data[8].dataValue1 !== null ? result.data[8].dataValue1 : "");
    //         setM10Value1(result.data[9].dataValue1 !== null ? result.data[9].dataValue1 : "");
    //         setM11Value1(result.data[10].dataValue1 !== null ? result.data[10].dataValue1 : "");
    //         setM12Value1(result.data[11].dataValue1 !== null ? result.data[11].dataValue1 : "");
    //         setAddMonth(true);
    //       }
    //     },
    //     error => {
    //       setAddMonth(false);
    //       setShowAddMonth(true);
    //       //alert(error);
    //     }
    //   );

    axios(" /api/v1/dataOtherOptions2?dataId=" + dataId + "&year=" + year, {
      method: "GET"
    })
      .then(response => response.data)
      .then(
        result => {
          setOptionsDataGroup(result);
          clearM2();
          if (isAddGroup) {
            setData1("");
            setData2("");
          }
        },
        error => {}
      );
  }, [year]);

  const handleConfirm = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    // const requestOptions = {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json-patch+json"
    //   },
    //   body: JSON.stringify({
    //     Name: name,
    //     Objective: objective,
    //     Definition: definition,
    //     DataSource: dataSource,
    //     Responsible: responsible,
    //     Informant: informant,
    //     Target: target,
    //     Group1Id: option1,
    //     Group2Id: option2,
    //     Group3Id: option3,
    //     Group4Id: option4,
    //     UnitId: unit,
    //     TypeId: type,
    //     ShowId: show,
    //     FrequencyId: frequency
    //   })
    // };


    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setCalMonth(result.data.calMonth);
    //       setCalYear(result.data.calYear);
    //       setShowAdd(false);
    //       //setShowAddMonth(true);
    //       setDisable2(false);
    //       setValue(result.data.dataId.toString());
    //       setLabel(result.data.name);
    //       setAdd(true);
    //       setShowMonth(true);
    //       setModal(false);
    //       setDataId(result.data.dataId);
    //       setIcon("far fa-question-circle");
    //       setIsAddGroup(true);
    //     },
    //     error => {
    //       alert(error);
    //     }
    //   );

      var js = {
        Name: name,
        Objective: objective,
        Definition: definition,
        DataSource: dataSource,
        Responsible: responsible,
        Informant: informant,
        Target: target,
        Group1Id: option1,
        Group2Id: option2,
        Group3Id: option3,
        Group4Id: option4,
        UnitId: unit,
        TypeId: type,
        ShowId: show,
        FrequencyId: frequency,
        Division: divide,
        creatorCode: currentUser.userName,
        LastediterCode: currentUser.userName,
        Responsible: responsibleL,
      }

      axios.post("/api/v1/data/", js)
      .then (
        result => {
          var res = result.data;
          setCalMonth(res.data.calMonth);
          setCalYear(res.data.calYear);
          setShowAdd(false);
          //setShowAddMonth(true);
          setDisable2(false);
          setValue(res.data.dataId.toString());
          setLabel(res.data.name);
          setAdd(true);
          setShowMonth(true);
          setModal(false);
          setDataId(res.data.dataId);
          setIcon("far fa-question-circle");
          setIsAddGroup(true);
          axios("/api/v1/responsible/" + res.data.dataId)
          .then(
            result => {
              var res = result.data;
              setResponsibleL(res);
              var a = check(res, currentUser.userName);
              if(a) {
                setIsResponsible(true);
              } else {
                setIsResponsible(false);
              }
            }, error => {
              setIsResponsible(false);
              console.log(error);
            }
          );  
        },
        error => { console.log(error);}
      );
  };

  const handleConfirmUpdate = evt => {
    evt.preventDefault();
    setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");

    var edit = {
      Name: name,
      Objective: objective,
      Definition: definition,
      DataSource: dataSource,
      // Responsible: responsible,
      Informant: informant,
      Target: target,
      Group1Id: option1,
      Group2Id: option2,
      Group3Id: option3,
      Group4Id: option4,
      UnitId: unit,
      TypeId: type,
      ShowId: show,
      IsFetch: isFetch,
      FrequencyId: frequency,
      Division: divide,
      LastediterCode: currentUser.userName,
      Responsible: responsibleL,
    };


    //   method: "PUT",
    //   headers: { "Content-Type": "application/json-patch+json" },
    //   body: JSON.stringify(edit)
    // })
    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setShowAdd(false);
    //       //setShowAddMonth(true);
    //       setDisable2(false);
    //       setDisable3(false);
    //       setValue(result.data.dataId.toString());
    //       setLabel(result.data.name);
    //       setModal3(false);
    //       setDataId(result.data.dataId);
    //       setIcon("far fa-question-circle");
    //       setUpdate(true);
    //     },
    //     error => {
    //       alert(error);
    //     }
    //   );

    axios.put("/api/v1/data/" + dataId, edit)
    .then (
      result => {
      var res = result.data;
      setShowAdd(false);
      //setShowAddMonth(true);
      setDisable2(false);
      setDisable3(false);
      setValue(res.data.dataId.toString());
      setLabel(res.data.name);
      setModal3(false);
      setDataId(res.data.dataId);
      setIcon("far fa-question-circle");
      setUpdate(true);

      axios("/api/v1/responsible/" + res.data.dataId)
      .then(
        result => {
          var res = result.data;
          setResponsibleL(res);
          var a = check(res, currentUser.userName);
          if(a) {
            setIsResponsible(true);
          } else {
            setIsResponsible(false);
          }
        }, error => {
          setIsResponsible(false);
          console.log(error);
        }
      );  
      },
      error => { console.log(error);}
    );
  };

  const handleConfirmMonth = evt => {
    evt.preventDefault();
    setIcon2("fa fa-spinner fa-w-16 fa-spin fa-lg");
    
    // const requestOptions = {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json-patch+json"
    //   },
    //   body: JSON.stringify({
    //     Name: name,
    //     DataId: dataId,
    //     Year: year,
    //     DataGroup: dataGroup,
    //     M1Value1: m1Value1,
    //     M2Value1: m2Value1,
    //     M3Value1: m3Value1,
    //     M4Value1: m4Value1,
    //     M5Value1: m5Value1,
    //     M6Value1: m6Value1,
    //     M7Value1: m7Value1,
    //     M8Value1: m8Value1,
    //     M9Value1: m9Value1,
    //     M10Value1: m10Value1,
    //     M11Value1: m11Value1,
    //     M12Value1: m12Value1,
    //     M1Value2: m1Value2,
    //     M2Value2: m2Value2,
    //     M3Value2: m3Value2,
    //     M4Value2: m4Value2,
    //     M5Value2: m5Value2,
    //     M6Value2: m6Value2,
    //     M7Value2: m7Value2,
    //     M8Value2: m8Value2,
    //     M9Value2: m9Value2,
    //     M10Value2: m10Value2,
    //     M11Value2: m11Value2,
    //     M12Value2: m12Value2,
    //     M1Target: m1Target,
    //     M2Target: m2Target,
    //     M3Target: m3Target,
    //     M4Target: m4Target,
    //     M5Target: m5Target,
    //     M6Target: m6Target,
    //     M7Target: m7Target,
    //     M8Target: m8Target,
    //     M9Target: m9Target,
    //     M10Target: m10Target,
    //     M11Target: m11Target,
    //     M12Target: m12Target,
    //     UnitId: unit,
    //     Data1: data1,
    //     Data2: data2,
    //     GroupName: groupName,
    //     M1Approve: m1Approve === "" ? false : m1Approve,
    //     M2Approve: m2Approve === "" ? false : m2Approve,
    //     M3Approve: m3Approve === "" ? false : m3Approve,
    //     M4Approve: m4Approve === "" ? false : m4Approve,
    //     M5Approve: m5Approve === "" ? false : m5Approve,
    //     M6Approve: m6Approve === "" ? false : m6Approve,
    //     M7Approve: m7Approve === "" ? false : m7Approve,
    //     M8Approve: m8Approve === "" ? false : m8Approve,
    //     M9Approve: m9Approve === "" ? false : m9Approve,
    //     M10Approve: m10Approve === "" ? false : m10Approve,
    //     M11Approve: m11Approve === "" ? false : m11Approve,
    //     M12Approve: m12Approve === "" ? false : m12Approve,
    //     Link1: m1Link,
    //     Link2: m2Link,
    //     Link3: m3Link,
    //     Link4: m4Link,
    //     Link5: m5Link,
    //     Link6: m6Link,
    //     Link7: m7Link,
    //     Link8: m8Link,
    //     Link9: m9Link,
    //     Link10: m10Link,
    //     Link11: m11Link,
    //     Link12: m12Link,
    //     IsAddGroup: isAddGroup
    //   })
    // };


    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setModal2(false);
    //       setIcon2("far fa-question-circle");
    //       setDisableGroup(false);
    //       setDataGroup(result.dataGroup);
    //       console.log(result);


    //         " /api/v1/dataOtherOptions2?dataId=" + dataId + "&year=" + year,
    //         {
    //           method: "GET"
    //         }
    //       )
    //         .then(response => response.json())
    //         .then(
    //           result3 => {
    //             setOptionsDataGroup(result3);
    //             setAddMonth(true);
    //             setIsAddGroup(false);
    //           },
    //           error => {
    //             setAddMonth(false);
    //             alert(error);
    //           }
    //         );

    //         "/api/v1/data/month?dataId=" +
    //           dataId +
    //           "&year=" +
    //           year +
    //           "&dataGroup=" +
    //           dataGroup,
    //         {
    //           method: "GET"
    //         }
    //       )
    //         .then(response => response.json())
    //         .then(
    //           result2 => {
    //             console.log(result2);
    //             setM1Target(result2.data[0].target);
    //             setM2Target(result2.data[1].target);
    //             setM3Target(result2.data[2].target);
    //             setM4Target(result2.data[3].target);
    //             setM5Target(result2.data[4].target);
    //             setM6Target(result2.data[5].target);
    //             setM7Target(result2.data[6].target);
    //             setM8Target(result2.data[7].target);
    //             setM9Target(result2.data[8].target);
    //             setM10Target(result2.data[9].target);
    //             setM11Target(result2.data[10].target);
    //             setM12Target(result2.data[11].target);
    //             setM1Approve(result2.data[0].isApprove);
    //             setM2Approve(result2.data[1].isApprove);
    //             setM3Approve(result2.data[2].isApprove);
    //             setM4Approve(result2.data[3].isApprove);
    //             setM5Approve(result2.data[4].isApprove);
    //             setM6Approve(result2.data[5].isApprove);
    //             setM7Approve(result2.data[6].isApprove);
    //             setM8Approve(result2.data[7].isApprove);
    //             setM9Approve(result2.data[8].isApprove);
    //             setM10Approve(result2.data[9].isApprove);
    //             setM11Approve(result2.data[10].isApprove);
    //             setM12Approve(result2.data[11].isApprove);
    //             setGroupName(result2.data[0].name);
    //             setM1Link(result2.data[0].link);
    //             setM2Link(result2.data[1].link);
    //             setM3Link(result2.data[2].link);
    //             setM4Link(result2.data[3].link);
    //             setM5Link(result2.data[4].link);
    //             setM6Link(result2.data[5].link6);
    //             setM7Link(result2.data[6].link);
    //             setM8Link(result2.data[7].link);
    //             setM9Link(result2.data[8].link);
    //             setM10Link(result2.data[9].link);
    //             setM11Link(result2.data[10].link);
    //             setM12Link(result2.data[11].link);
    //             if (unit === 1 || unit === 3) {
    //               setM1Value1(result2.data[0].dataValue1);
    //               setM1Value2(result2.data[0].dataValue2);
    //               setM2Value1(result2.data[1].dataValue1);
    //               setM2Value2(result2.data[1].dataValue2);
    //               setM3Value1(result2.data[2].dataValue1);
    //               setM3Value2(result2.data[2].dataValue2);
    //               setM4Value1(result2.data[3].dataValue1);
    //               setM4Value2(result2.data[3].dataValue2);
    //               setM5Value1(result2.data[4].dataValue1);
    //               setM5Value2(result2.data[4].dataValue2);
    //               setM6Value1(result2.data[5].dataValue1);
    //               setM6Value2(result2.data[5].dataValue2);
    //               setM7Value1(result2.data[6].dataValue1);
    //               setM7Value2(result2.data[6].dataValue2);
    //               setM8Value1(result2.data[7].dataValue1);
    //               setM8Value2(result2.data[7].dataValue2);
    //               setM9Value1(result2.data[8].dataValue1);
    //               setM9Value2(result2.data[8].dataValue2);
    //               setM10Value1(result2.data[9].dataValue1);
    //               setM10Value2(result2.data[9].dataValue2);
    //               setM11Value1(result2.data[10].dataValue1);
    //               setM11Value2(result2.data[10].dataValue2);
    //               setM12Value1(result2.data[11].dataValue1);
    //               setM12Value2(result2.data[11].dataValue2);
    //               setAddMonth(true);
    //             } else if (unit === 2 || unit === 4) {
    //               setM1Value1(result2.data[0].dataValue1);
    //               setM2Value1(result2.data[1].dataValue1);
    //               setM3Value1(result2.data[2].dataValue1);
    //               setM4Value1(result2.data[3].dataValue1);
    //               setM5Value1(result2.data[4].dataValue1);
    //               setM6Value1(result2.data[5].dataValue1);
    //               setM7Value1(result2.data[6].dataValue1);
    //               setM8Value1(result2.data[7].dataValue1);
    //               setM9Value1(result2.data[8].dataValue1);
    //               setM10Value1(result2.data[9].dataValue1);
    //               setM11Value1(result2.data[10].dataValue1);
    //               setM12Value1(result2.data[11].dataValue1);
    //               setAddMonth(true);
    //             }

    //             if (calMonth === 1) {
    //               setM1Approve(true);
    //             } else if (calMonth === 2) {
    //               setM2Approve(true);
    //             } else if (calMonth === 3) {
    //               setM3Approve(true);
    //             } else if (calMonth === 4) {
    //               setM4Approve(true);
    //             } else if (calMonth === 5) {
    //               setM5Approve(true);
    //             } else if (calMonth === 6) {
    //               setM6Approve(true);
    //             } else if (calMonth === 7) {
    //               setM7Approve(true);
    //             } else if (calMonth === 8) {
    //               setM8Approve(true);
    //             } else if (calMonth === 9) {
    //               setM9Approve(true);
    //             } else if (calMonth === 10) {
    //               setM10Approve(true);
    //             } else if (calMonth === 11) {
    //               setM11Approve(true);
    //             } else if (calMonth === 12) {
    //               setM12Approve(true);
    //             }
    //           },
    //           error => {
    //             setAddMonth(false);
    //             alert(error);
    //           }
    //         );
    //     },
    //     error => {
    //       alert(error);
    //     }
    //   );

      var js = {
        Name: name,
        DataId: dataId,
        Year: year,
        DataGroup: dataGroup,
        M1Value1: m1Value1,
        M2Value1: m2Value1,
        M3Value1: m3Value1,
        M4Value1: m4Value1,
        M5Value1: m5Value1,
        M6Value1: m6Value1,
        M7Value1: m7Value1,
        M8Value1: m8Value1,
        M9Value1: m9Value1,
        M10Value1: m10Value1,
        M11Value1: m11Value1,
        M12Value1: m12Value1,
        M1Value2: m1Value2,
        M2Value2: m2Value2,
        M3Value2: m3Value2,
        M4Value2: m4Value2,
        M5Value2: m5Value2,
        M6Value2: m6Value2,
        M7Value2: m7Value2,
        M8Value2: m8Value2,
        M9Value2: m9Value2,
        M10Value2: m10Value2,
        M11Value2: m11Value2,
        M12Value2: m12Value2,
        M1Target: m1Target,
        M2Target: m2Target,
        M3Target: m3Target,
        M4Target: m4Target,
        M5Target: m5Target,
        M6Target: m6Target,
        M7Target: m7Target,
        M8Target: m8Target,
        M9Target: m9Target,
        M10Target: m10Target,
        M11Target: m11Target,
        M12Target: m12Target,
        UnitId: unit,
        Data1: data1,
        Data2: data2,
        GroupName: groupName,
        M1Approve: m1Approve === "" ? false : m1Approve,
        M2Approve: m2Approve === "" ? false : m2Approve,
        M3Approve: m3Approve === "" ? false : m3Approve,
        M4Approve: m4Approve === "" ? false : m4Approve,
        M5Approve: m5Approve === "" ? false : m5Approve,
        M6Approve: m6Approve === "" ? false : m6Approve,
        M7Approve: m7Approve === "" ? false : m7Approve,
        M8Approve: m8Approve === "" ? false : m8Approve,
        M9Approve: m9Approve === "" ? false : m9Approve,
        M10Approve: m10Approve === "" ? false : m10Approve,
        M11Approve: m11Approve === "" ? false : m11Approve,
        M12Approve: m12Approve === "" ? false : m12Approve,
        Link1: m1Link,
        Link2: m2Link,
        Link3: m3Link,
        Link4: m4Link,
        Link5: m5Link,
        Link6: m6Link,
        Link7: m7Link,
        Link8: m8Link,
        Link9: m9Link,
        Link10: m10Link,
        Link11: m11Link,
        Link12: m12Link,
        IsAddGroup: isAddGroup
      }

      axios.post("/api/v1/data/month", js)
      .then (
        result => {
        var res = result.data;
        setModal2(false);
        setIcon2("far fa-question-circle");
        setDisableGroup(false);
        setDataGroup(res.dataGroup);

        axios.get("/api/v1/dataOtherOptions2?dataId=" + dataId + "&year=" + year)
        .then(
        result2 => {
          //var res = result2.data;
          setOptionsDataGroup(result2);
          setAddMonth(true);
          setIsAddGroup(false);
           
        }, 
          error => {
            setAddMonth(false);
            console.log(error);}
        );  

        axios.get("/api/v1/data/month?dataId=" +
          dataId +
          "&year=" +
          year +
          "&dataGroup=" +
          dataGroup 
        )
        .then(
        result3 => {
          var res = result3.data;
          setM1Target(res.data[0].target);
          setM2Target(res.data[1].target);
          setM3Target(res.data[2].target);
          setM4Target(res.data[3].target);
          setM5Target(res.data[4].target);
          setM6Target(res.data[5].target);
          setM7Target(res.data[6].target);
          setM8Target(res.data[7].target);
          setM9Target(res.data[8].target);
          setM10Target(res.data[9].target);
          setM11Target(res.data[10].target);
          setM12Target(res.data[11].target);
          setM1Approve(res.data[0].isApprove);
          setM2Approve(res.data[1].isApprove);
          setM3Approve(res.data[2].isApprove);
          setM4Approve(res.data[3].isApprove);
          setM5Approve(res.data[4].isApprove);
          setM6Approve(res.data[5].isApprove);
          setM7Approve(res.data[6].isApprove);
          setM8Approve(res.data[7].isApprove);
          setM9Approve(res.data[8].isApprove);
          setM10Approve(res.data[9].isApprove);
          setM11Approve(res.data[10].isApprove);
          setM12Approve(res.data[11].isApprove);
          setGroupName(res.data[0].name);
          setM1Link(res.data[0].link);
          setM2Link(res.data[1].link);
          setM3Link(res.data[2].link);
          setM4Link(res.data[3].link);
          setM5Link(res.data[4].link);
          setM6Link(res.data[5].link6);
          setM7Link(res.data[6].link);
          setM8Link(res.data[7].link);
          setM9Link(res.data[8].link);
          setM10Link(res.data[9].link);
          setM11Link(res.data[10].link);
          setM12Link(res.data[11].link);
          if (unit === 1 || unit === 3) {
            setM1Value1(res.data[0].dataValue1);
            setM1Value2(res.data[0].dataValue2);
            setM2Value1(res.data[1].dataValue1);
            setM2Value2(res.data[1].dataValue2);
            setM3Value1(res.data[2].dataValue1);
            setM3Value2(res.data[2].dataValue2);
            setM4Value1(res.data[3].dataValue1);
            setM4Value2(res.data[3].dataValue2);
            setM5Value1(res.data[4].dataValue1);
            setM5Value2(res.data[4].dataValue2);
            setM6Value1(res.data[5].dataValue1);
            setM6Value2(res.data[5].dataValue2);
            setM7Value1(res.data[6].dataValue1);
            setM7Value2(res.data[6].dataValue2);
            setM8Value1(res.data[7].dataValue1);
            setM8Value2(res.data[7].dataValue2);
            setM9Value1(res.data[8].dataValue1);
            setM9Value2(res.data[8].dataValue2);
            setM10Value1(res.data[9].dataValue1);
            setM10Value2(res.data[9].dataValue2);
            setM11Value1(res.data[10].dataValue1);
            setM11Value2(res.data[10].dataValue2);
            setM12Value1(res.data[11].dataValue1);
            setM12Value2(res.data[11].dataValue2);
            setAddMonth(true);
          } else if (unit === 2 || unit === 4) {
            setM1Value1(res.data[0].dataValue1);
            setM2Value1(res.data[1].dataValue1);
            setM3Value1(res.data[2].dataValue1);
            setM4Value1(res.data[3].dataValue1);
            setM5Value1(res.data[4].dataValue1);
            setM6Value1(res.data[5].dataValue1);
            setM7Value1(res.data[6].dataValue1);
            setM8Value1(res.data[7].dataValue1);
            setM9Value1(res.data[8].dataValue1);
            setM10Value1(res.data[9].dataValue1);
            setM11Value1(res.data[10].dataValue1);
            setM12Value1(res.data[11].dataValue1);
            setAddMonth(true);
          }

          // if (calMonth === 1) {
          //   setM1Approve(true);
          // } else if (calMonth === 2) {
          //   setM2Approve(true);
          // } else if (calMonth === 3) {
          //   setM3Approve(true);
          // } else if (calMonth === 4) {
          //   setM4Approve(true);
          // } else if (calMonth === 5) {
          //   setM5Approve(true);
          // } else if (calMonth === 6) {
          //   setM6Approve(true);
          // } else if (calMonth === 7) {
          //   setM7Approve(true);
          // } else if (calMonth === 8) {
          //   setM8Approve(true);
          // } else if (calMonth === 9) {
          //   setM9Approve(true);
          // } else if (calMonth === 10) {
          //   setM10Approve(true);
          // } else if (calMonth === 11) {
          //   setM11Approve(true);
          // } else if (calMonth === 12) {
          //   setM12Approve(true);
          // }
           
        }, 
          error => {
            setAddMonth(false);
            console.log(error);}
        );  
      },
        error => { console.log(error);}
      );
  };

  const handleConfirmMonthUpdate = evt => {
    evt.preventDefault();
    setIcon2("fa fa-spinner fa-w-16 fa-spin fa-lg");

    var edit = {
      Name: data1,
      DataId: dataId,
      Year: year,
      M1Value1: m1Value1,
      M2Value1: m2Value1,
      M3Value1: m3Value1,
      M4Value1: m4Value1,
      M5Value1: m5Value1,
      M6Value1: m6Value1,
      M7Value1: m7Value1,
      M8Value1: m8Value1,
      M9Value1: m9Value1,
      M10Value1: m10Value1,
      M11Value1: m11Value1,
      M12Value1: m12Value1,
      M1Value2: m1Value2,
      M2Value2: m2Value2,
      M3Value2: m3Value2,
      M4Value2: m4Value2,
      M5Value2: m5Value2,
      M6Value2: m6Value2,
      M7Value2: m7Value2,
      M8Value2: m8Value2,
      M9Value2: m9Value2,
      M10Value2: m10Value2,
      M11Value2: m11Value2,
      M12Value2: m12Value2,
      M1Target: m1Target,
      M2Target: m2Target,
      M3Target: m3Target,
      M4Target: m4Target,
      M5Target: m5Target,
      M6Target: m6Target,
      M7Target: m7Target,
      M8Target: m8Target,
      M9Target: m9Target,
      M10Target: m10Target,
      M11Target: m11Target,
      M12Target: m12Target,
      UnitId: unit,
      Data1: data1,
      Data2: data2,
      GroupName: groupName,
      DataGroup: dataGroup,
      M1Approve: m1Approve === "" ? false : m1Approve,
      M2Approve: m2Approve === "" ? false : m2Approve,
      M3Approve: m3Approve === "" ? false : m3Approve,
      M4Approve: m4Approve === "" ? false : m4Approve,
      M5Approve: m5Approve === "" ? false : m5Approve,
      M6Approve: m6Approve === "" ? false : m6Approve,
      M7Approve: m7Approve === "" ? false : m7Approve,
      M8Approve: m8Approve === "" ? false : m8Approve,
      M9Approve: m9Approve === "" ? false : m9Approve,
      M10Approve: m10Approve === "" ? false : m10Approve,
      M11Approve: m11Approve === "" ? false : m11Approve,
      M12Approve: m12Approve === "" ? false : m12Approve,
      Link1: m1Link,
      Link2: m2Link,
      Link3: m3Link,
      Link4: m4Link,
      Link5: m5Link,
      Link6: m6Link,
      Link7: m7Link,
      Link8: m8Link,
      Link9: m9Link,
      Link10: m10Link,
      Link11: m11Link,
      Link12: m12Link,
      Division: divide
    };


    //   method: "PUT",
    //   headers: { "Content-Type": "application/json-patch+json" },
    //   body: JSON.stringify(edit)
    // })
    //   .then(response => response.json())
    //   .then(
    //     result => {
    //       setModal4(false);
    //       setIcon2("far fa-question-circle");

    //         "/api/v1/data/month?dataId=" +
    //           dataId +
    //           "&year=" +
    //           year +
    //           "&dataGroup=" +
    //           dataGroup,
    //         {
    //           method: "GET"
    //         }
    //       )
    //         .then(response => response.json())
    //         .then(
    //           result2 => {
    //             setM1Target(result2.data[0].target);
    //             setM2Target(result2.data[1].target);
    //             setM3Target(result2.data[2].target);
    //             setM4Target(result2.data[3].target);
    //             setM5Target(result2.data[4].target);
    //             setM6Target(result2.data[5].target);
    //             setM7Target(result2.data[6].target);
    //             setM8Target(result2.data[7].target);
    //             setM9Target(result2.data[8].target);
    //             setM10Target(result2.data[9].target);
    //             setM11Target(result2.data[10].target);
    //             setM12Target(result2.data[11].target);
    //             setM1Approve(result2.data[0].isApprove);
    //             setM2Approve(result2.data[1].isApprove);
    //             setM3Approve(result2.data[2].isApprove);
    //             setM4Approve(result2.data[3].isApprove);
    //             setM5Approve(result2.data[4].isApprove);
    //             setM6Approve(result2.data[5].isApprove);
    //             setM7Approve(result2.data[6].isApprove);
    //             setM8Approve(result2.data[7].isApprove);
    //             setM9Approve(result2.data[8].isApprove);
    //             setM10Approve(result2.data[9].isApprove);
    //             setM11Approve(result2.data[10].isApprove);
    //             setM12Approve(result2.data[11].isApprove);
    //             setGroupName(result2.data[0].name);
    //             setM1Link(result2.data[0].link);
    //             setM2Link(result2.data[1].link);
    //             setM3Link(result2.data[2].link);
    //             setM4Link(result2.data[3].link);
    //             setM5Link(result2.data[4].link);
    //             setM6Link(result2.data[5].link);
    //             setM7Link(result2.data[6].link);
    //             setM8Link(result2.data[7].link);
    //             setM9Link(result2.data[8].link);
    //             setM10Link(result2.data[9].link);
    //             setM11Link(result2.data[10].link);
    //             setM12Link(result2.data[11].link);
    //             if (unit === 1 || unit === 3) {
    //               setM1Value1(
    //                 result2.data[0].dataValue1 === null
    //                   ? ""
    //                   : result2.data[0].dataValue1
    //               );
    //               setM1Value2(
    //                 result2.data[0].dataValue2 === null
    //                   ? ""
    //                   : result2.data[0].dataValue2
    //               );
    //               setM2Value1(
    //                 result2.data[1].dataValue1 === null
    //                   ? ""
    //                   : result2.data[1].dataValue1
    //               );
    //               setM2Value2(
    //                 result2.data[1].dataValue2 === null
    //                   ? ""
    //                   : result2.data[1].dataValue2
    //               );
    //               setM3Value1(
    //                 result2.data[2].dataValue1 === null
    //                   ? ""
    //                   : result2.data[2].dataValue1
    //               );
    //               setM3Value2(
    //                 result2.data[2].dataValue2 === null
    //                   ? ""
    //                   : result2.data[2].dataValue2
    //               );
    //               setM4Value1(
    //                 result2.data[3].dataValue1 === null
    //                   ? ""
    //                   : result2.data[3].dataValue1
    //               );
    //               setM4Value2(
    //                 result2.data[3].dataValue2 === null
    //                   ? ""
    //                   : result2.data[3].dataValue2
    //               );
    //               setM5Value1(
    //                 result2.data[3].dataValue1 === null
    //                   ? ""
    //                   : result2.data[4].dataValue1
    //               );
    //               setM5Value2(
    //                 result2.data[4].dataValue2 === null
    //                   ? ""
    //                   : result2.data[4].dataValue2
    //               );
    //               setM6Value1(
    //                 result2.data[5].dataValue1 === null
    //                   ? ""
    //                   : result2.data[5].dataValue1
    //               );
    //               setM6Value2(
    //                 result2.data[5].dataValue2 === null
    //                   ? ""
    //                   : result2.data[5].dataValue2
    //               );
    //               setM7Value1(
    //                 result2.data[6].dataValue1 === null
    //                   ? ""
    //                   : result2.data[6].dataValue1
    //               );
    //               setM7Value2(
    //                 result2.data[6].dataValue2 === null
    //                   ? ""
    //                   : result2.data[6].dataValue2
    //               );
    //               setM8Value1(
    //                 result2.data[7].dataValue1 === null
    //                   ? ""
    //                   : result2.data[7].dataValue1
    //               );
    //               setM8Value2(
    //                 result2.data[7].dataValue2 === null
    //                   ? ""
    //                   : result2.data[7].dataValue2
    //               );
    //               setM9Value1(
    //                 result2.data[8].dataValue1 === null
    //                   ? ""
    //                   : result2.data[8].dataValue1
    //               );
    //               setM9Value2(
    //                 result2.data[8].dataValue2 === null
    //                   ? ""
    //                   : result2.data[8].dataValue2
    //               );
    //               setM10Value1(
    //                 result2.data[9].dataValue1 === null
    //                   ? ""
    //                   : result2.data[9].dataValue1
    //               );
    //               setM10Value2(
    //                 result2.data[9].dataValue2 === null
    //                   ? ""
    //                   : result2.data[9].dataValue2
    //               );
    //               setM11Value1(
    //                 result2.data[10].dataValue1 === null
    //                   ? ""
    //                   : result2.data[10].dataValue1
    //               );
    //               setM11Value2(
    //                 result2.data[10].dataValue2 === null
    //                   ? ""
    //                   : result2.data[10].dataValue2
    //               );
    //               setM12Value1(
    //                 result2.data[11].dataValue1 === null
    //                   ? ""
    //                   : result2.data[11].dataValue1
    //               );
    //               setM12Value2(
    //                 result2.data[11].dataValue2 === null
    //                   ? ""
    //                   : result2.data[11].dataValue2
    //               );
    //               setAddMonth(true);
    //             } else if (unit === 2 || unit === 4) {
    //               setM1Value1(
    //                 result2.data[0].dataValue1 === null
    //                   ? ""
    //                   : result2.data[0].dataValue1
    //               );
    //               setM2Value1(
    //                 result2.data[1].dataValue1 === null
    //                   ? ""
    //                   : result2.data[1].dataValue1
    //               );
    //               setM3Value1(
    //                 result2.data[2].dataValue1 === null
    //                   ? ""
    //                   : result2.data[2].dataValue1
    //               );
    //               setM4Value1(
    //                 result2.data[3].dataValue1 === null
    //                   ? ""
    //                   : result2.data[3].dataValue1
    //               );
    //               setM5Value1(
    //                 result2.data[4].dataValue1 === null
    //                   ? ""
    //                   : result2.data[4].dataValue1
    //               );
    //               setM6Value1(
    //                 result2.data[5].dataValue1 === null
    //                   ? ""
    //                   : result2.data[5].dataValue1
    //               );
    //               setM7Value1(
    //                 result2.data[6].dataValue1 === null
    //                   ? ""
    //                   : result2.data[6].dataValue1
    //               );
    //               setM8Value1(
    //                 result2.data[7].dataValue1 === null
    //                   ? ""
    //                   : result2.data[7].dataValue1
    //               );
    //               setM9Value1(
    //                 result2.data[8].dataValue1 === null
    //                   ? ""
    //                   : result2.data[8].dataValue1
    //               );
    //               setM10Value1(
    //                 result2.data[9].dataValue1 === null
    //                   ? ""
    //                   : result2.data[9].dataValue1
    //               );
    //               setM11Value1(
    //                 result2.data[10].dataValue1 === null
    //                   ? ""
    //                   : result2.data[10].dataValue1
    //               );
    //               setM12Value1(
    //                 result2.data[11].dataValue1 === null
    //                   ? ""
    //                   : result2.data[11].dataValue1
    //               );
    //               setAddMonth(true);
    //             }

    //             if (calMonth === 1) {
    //               setM1Approve(true);
    //             } else if (calMonth === 2) {
    //               setM2Approve(true);
    //             } else if (calMonth === 3) {
    //               setM3Approve(true);
    //             } else if (calMonth === 4) {
    //               setM4Approve(true);
    //             } else if (calMonth === 5) {
    //               setM5Approve(true);
    //             } else if (calMonth === 6) {
    //               setM6Approve(true);
    //             } else if (calMonth === 7) {
    //               setM7Approve(true);
    //             } else if (calMonth === 8) {
    //               setM8Approve(true);
    //             } else if (calMonth === 9) {
    //               setM9Approve(true);
    //             } else if (calMonth === 10) {
    //               setM10Approve(true);
    //             } else if (calMonth === 11) {
    //               setM11Approve(true);
    //             } else if (calMonth === 12) {
    //               setM12Approve(true);
    //             }
    //           },
    //           error => {
    //             setAddMonth(false);
    //             alert(error);
    //           }
    //         );
    //     },
    //     error => {
    //       alert(error);
    //     }
    //   );

      axios.put("/api/v1/data/month/" + dataId, edit)
      .then (
        result => {
          setModal4(false);
          setIcon2("far fa-question-circle");
          axios.get("/api/v1/data/month?dataId=" +
                    dataId +
                    "&year=" +
                    year +
                    "&dataGroup=" +
                    dataGroup)
          .then (
          res => {
            var result2 = res.data;
            setM1Target(result2.data[0].target);
            setM2Target(result2.data[1].target);
            setM3Target(result2.data[2].target);
            setM4Target(result2.data[3].target);
            setM5Target(result2.data[4].target);
            setM6Target(result2.data[5].target);
            setM7Target(result2.data[6].target);
            setM8Target(result2.data[7].target);
            setM9Target(result2.data[8].target);
            setM10Target(result2.data[9].target);
            setM11Target(result2.data[10].target);
            setM12Target(result2.data[11].target);
            setM1Approve(result2.data[0].isApprove);
            setM2Approve(result2.data[1].isApprove);
            setM3Approve(result2.data[2].isApprove);
            setM4Approve(result2.data[3].isApprove);
            setM5Approve(result2.data[4].isApprove);
            setM6Approve(result2.data[5].isApprove);
            setM7Approve(result2.data[6].isApprove);
            setM8Approve(result2.data[7].isApprove);
            setM9Approve(result2.data[8].isApprove);
            setM10Approve(result2.data[9].isApprove);
            setM11Approve(result2.data[10].isApprove);
            setM12Approve(result2.data[11].isApprove);
            setGroupName(result2.data[0].name);
            setM1Link(result2.data[0].link);
            setM2Link(result2.data[1].link);
            setM3Link(result2.data[2].link);
            setM4Link(result2.data[3].link);
            setM5Link(result2.data[4].link);
            setM6Link(result2.data[5].link);
            setM7Link(result2.data[6].link);
            setM8Link(result2.data[7].link);
            setM9Link(result2.data[8].link);
            setM10Link(result2.data[9].link);
            setM11Link(result2.data[10].link);
            setM12Link(result2.data[11].link);
            if (unit === 1 || unit === 3) {
              setM1Value1(
                result2.data[0].dataValue1 === null
                  ? ""
                  : result2.data[0].dataValue1
              );
              setM1Value2(
                result2.data[0].dataValue2 === null
                  ? ""
                  : result2.data[0].dataValue2
              );
              setM2Value1(
                result2.data[1].dataValue1 === null
                  ? ""
                  : result2.data[1].dataValue1
              );
              setM2Value2(
                result2.data[1].dataValue2 === null
                  ? ""
                  : result2.data[1].dataValue2
              );
              setM3Value1(
                result2.data[2].dataValue1 === null
                  ? ""
                  : result2.data[2].dataValue1
              );
              setM3Value2(
                result2.data[2].dataValue2 === null
                  ? ""
                  : result2.data[2].dataValue2
              );
              setM4Value1(
                result2.data[3].dataValue1 === null
                  ? ""
                  : result2.data[3].dataValue1
              );
              setM4Value2(
                result2.data[3].dataValue2 === null
                  ? ""
                  : result2.data[3].dataValue2
              );
              setM5Value1(
                result2.data[3].dataValue1 === null
                  ? ""
                  : result2.data[4].dataValue1
              );
              setM5Value2(
                result2.data[4].dataValue2 === null
                  ? ""
                  : result2.data[4].dataValue2
              );
              setM6Value1(
                result2.data[5].dataValue1 === null
                  ? ""
                  : result2.data[5].dataValue1
              );
              setM6Value2(
                result2.data[5].dataValue2 === null
                  ? ""
                  : result2.data[5].dataValue2
              );
              setM7Value1(
                result2.data[6].dataValue1 === null
                  ? ""
                  : result2.data[6].dataValue1
              );
              setM7Value2(
                result2.data[6].dataValue2 === null
                  ? ""
                  : result2.data[6].dataValue2
              );
              setM8Value1(
                result2.data[7].dataValue1 === null
                  ? ""
                  : result2.data[7].dataValue1
              );
              setM8Value2(
                result2.data[7].dataValue2 === null
                  ? ""
                  : result2.data[7].dataValue2
              );
              setM9Value1(
                result2.data[8].dataValue1 === null
                  ? ""
                  : result2.data[8].dataValue1
              );
              setM9Value2(
                result2.data[8].dataValue2 === null
                  ? ""
                  : result2.data[8].dataValue2
              );
              setM10Value1(
                result2.data[9].dataValue1 === null
                  ? ""
                  : result2.data[9].dataValue1
              );
              setM10Value2(
                result2.data[9].dataValue2 === null
                  ? ""
                  : result2.data[9].dataValue2
              );
              setM11Value1(
                result2.data[10].dataValue1 === null
                  ? ""
                  : result2.data[10].dataValue1
              );
              setM11Value2(
                result2.data[10].dataValue2 === null
                  ? ""
                  : result2.data[10].dataValue2
              );
              setM12Value1(
                result2.data[11].dataValue1 === null
                  ? ""
                  : result2.data[11].dataValue1
              );
              setM12Value2(
                result2.data[11].dataValue2 === null
                  ? ""
                  : result2.data[11].dataValue2
              );
              setAddMonth(true);
            } else if (unit === 2 || unit === 4) {
              setM1Value1(
                result2.data[0].dataValue1 === null
                  ? ""
                  : result2.data[0].dataValue1
              );
              setM2Value1(
                result2.data[1].dataValue1 === null
                  ? ""
                  : result2.data[1].dataValue1
              );
              setM3Value1(
                result2.data[2].dataValue1 === null
                  ? ""
                  : result2.data[2].dataValue1
              );
              setM4Value1(
                result2.data[3].dataValue1 === null
                  ? ""
                  : result2.data[3].dataValue1
              );
              setM5Value1(
                result2.data[4].dataValue1 === null
                  ? ""
                  : result2.data[4].dataValue1
              );
              setM6Value1(
                result2.data[5].dataValue1 === null
                  ? ""
                  : result2.data[5].dataValue1
              );
              setM7Value1(
                result2.data[6].dataValue1 === null
                  ? ""
                  : result2.data[6].dataValue1
              );
              setM8Value1(
                result2.data[7].dataValue1 === null
                  ? ""
                  : result2.data[7].dataValue1
              );
              setM9Value1(
                result2.data[8].dataValue1 === null
                  ? ""
                  : result2.data[8].dataValue1
              );
              setM10Value1(
                result2.data[9].dataValue1 === null
                  ? ""
                  : result2.data[9].dataValue1
              );
              setM11Value1(
                result2.data[10].dataValue1 === null
                  ? ""
                  : result2.data[10].dataValue1
              );
              setM12Value1(
                result2.data[11].dataValue1 === null
                  ? ""
                  : result2.data[11].dataValue1
              );
              setAddMonth(true);
            }

            // if (calMonth === 1) {
            //   setM1Approve(true);
            // } else if (calMonth === 2) {
            //   setM2Approve(true);
            // } else if (calMonth === 3) {
            //   setM3Approve(true);
            // } else if (calMonth === 4) {
            //   setM4Approve(true);
            // } else if (calMonth === 5) {
            //   setM5Approve(true);
            // } else if (calMonth === 6) {
            //   setM6Approve(true);
            // } else if (calMonth === 7) {
            //   setM7Approve(true);
            // } else if (calMonth === 8) {
            //   setM8Approve(true);
            // } else if (calMonth === 9) {
            //   setM9Approve(true);
            // } else if (calMonth === 10) {
            //   setM10Approve(true);
            // } else if (calMonth === 11) {
            //   setM11Approve(true);
            // } else if (calMonth === 12) {
            //   setM12Approve(true);
            // }
            
            },
            error => { 
              setAddMonth(false);
              console.log(error);
            }
          );

        },
        error => { console.log(error);}
      );
  };

  const setBoth2 = () => {
    setIsAddGroup(true);
    clearM();
    setDisableGroup(true);
    setData1("");
    setData2("");
    setGroupName("");
    //setCalMonth(0);
    //test();
    // if (calMonth === 1) {
    //   setM1Approve(true);
    // } else if (calMonth === 2) {
    //   setM2Approve(true);
    // } else if (calMonth === 3) {
    //   setM3Approve(true);
    // } else if (calMonth === 4) {
    //   setM4Approve(true);
    // } else if (calMonth === 5) {
    //   setM5Approve(true);
    // } else if (calMonth === 6) {
    //   setM6Approve(true);
    // } else if (calMonth === 7) {
    //   setM7Approve(true);
    // } else if (calMonth === 8) {
    //   setM8Approve(true);
    // } else if (calMonth === 9) {
    //   setM9Approve(true);
    // } else if (calMonth === 10) {
    //   setM10Approve(true);
    // } else if (calMonth === 11) {
    //   setM11Approve(true);
    // } else if (calMonth === 12) {
    //   setM12Approve(true);
    // }
  };

  const setBoth3 = () => {
    setIsAddGroup(false);
    setDisableGroup(false);
  };

  const onDelete2 = e => {
    setModalDelete2(true);
  };

  const handleDelete2 = evt => {
    evt.preventDefault();
    var cntErr = 0;
    var errMsg = [];

    if (dataGroup === 0) {
      cntErr += 1;
      errMsg.push(<li key={cntErr - 1}>{"กรุณาเลือกชุดข้อมูล"}</li>);
    }
    if (cntErr > 0) {
      setErrMsg(errMsg);
      setModalError(true);
    } else {
      setIcon("fa fa-spinner fa-w-16 fa-spin fa-lg");
      

      //   method: "DELETE"
      // })
      //   .then(response => response.text())
      //   .then(
      //     result => {
      //       var myBool = String("") === result;
      //       if (!myBool) {
      //         setModalDelete2(false);
      //         setIcon("far fa-question-circle");
      //         var errMsg = [];
      //         var cntErr = 0;

      //         cntErr += 1;
      //         errMsg.push(
      //           <li key={cntErr - 1}>{"เกิดข้อผิดพลาดกรุณาลองใหม่"}</li>
      //         );

      //         setErrMsg(errMsg);
      //         setModalError(true);
      //       } else {
      //         setModalDelete2(false);
      //         setIcon("far fa-question-circle");
      //         clearM(true);

      //           "/api/v1/dataOtherOptions2?dataId=" + dataId + "&year=" + year,
      //           {
      //             method: "GET"
      //           }
      //         )
      //           .then(response => response.json())
      //           .then(
      //             result => {
      //               setOptionsDataGroup(result);
      //             },
      //             error => {}
      //           );
      //       }
      //     },
      //     error => {
      //       alert(error);
      //     }
      //   );

        axios.delete("/api/v1/dataGroup?dataId=" + dataId + "&dataGroup=" + dataGroup)
        .then (
          result => {
          var res = result.data;
          setModalDelete2(false);
          setIcon("far fa-question-circle");
          clearM(true);

            axios("/api/v1/dataOtherOptions2?dataId=" + dataId + "&year=" + year)
            .then (
            result => {
              var res = result.data;
              setOptionsDataGroup(res);
            },
            error => { console.log(error);}
            );
          },
          error => { 
            setModalDelete(false);
            setIcon("far fa-question-circle");
            var errMsg = [];
            var cntErr = 0;
    
            cntErr += 1;
            errMsg.push(
            <li key={cntErr - 1}>
              {error.response.data}
            </li>
            );
    
            setErrMsg(errMsg);
            setModalError(true);
            console.log(error);
          }
        );
    }
  };

  // const test = e => {
  //   myRef.current.scrollIntoView();
  // };

  useEffect(() => {
    setOldYear(year);
  }, [year]);

  const location = useLocation();
  useEffect(() => {
    //const currentPath = location.pathname;
    const currentPath = location.pathname.split("/");
    //const searchParams = new URLSearchParams(location.pathname);
    if (currentPath[3] !== " ") {
      setDataId(Number(currentPath[3]));
    }
  }, [location]);

  useMemo(() => {
    const currentPath = location.pathname.split("/");
    if (currentPath[3] !== " ") {
      setDataId(Number(currentPath[3]));
    }

    // if (calMonth === 1) {
    //   setM1Approve(true);
    // } else if (calMonth === 2) {
    //   setM2Approve(true);
    // } else if (calMonth === 3) {
    //   setM3Approve(true);
    // } else if (calMonth === 4) {
    //   setM4Approve(true);
    // } else if (calMonth === 5) {
    //   setM5Approve(true);
    // } else if (calMonth === 6) {
    //   setM6Approve(true);
    // } else if (calMonth === 7) {
    //   setM7Approve(true);
    // } else if (calMonth === 8) {
    //   setM8Approve(true);
    // } else if (calMonth === 9) {
    //   setM9Approve(true);
    // } else if (calMonth === 10) {
    //   setM10Approve(true);
    // } else if (calMonth === 11) {
    //   setM11Approve(true);
    // } else if (calMonth === 12) {
    //   setM12Approve(true);
    // }
  }, [location]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios("/api/v1/data/" + dataId, {
        method: "GET"
      });
      if (response.status !== 200) {
        console.log("");
      } else {
        axios("/api/v1/responsible/" + dataId)
        .then(
          result => {
            var res = result.data;
            setResponsibleL(res);
            var a = check(res, currentUser.userName);
            if(a) {
              setIsResponsible(true);
            } else {
              setIsResponsible(false);
            }
          }, error => {
            setIsResponsible(false);
            console.log(error);
          }
        );  
        const data = response.data;
        setOption1(data.data.group1Id === null ? 0 : data.data.group1Id);
        setOption2(data.data.group2Id === null ? 0 : data.data.group2Id);
        if (data.data.group3Id !== null && data.data.group4Id !== undefined) {
          setOption3(data.data.group3Id);
        }
        if (data.data.group4Id !== null) {
          setOption4(data.data.group4Id);
          setOption5(data.data.dataId);
        } else if (data.data.group4Id === null) {
          setOption4(data.data.dataId);
        }
      }
    };
    fetchData().catch(error => console.error(error));
  }, [dataId]);

  const getCalM = (v1, v2, divide) => {
    if(divide === 1 && ((v1 === 0 && v2 === 0) ||
    (v1 === "0" && v2 === "0") ||
    (v1 === 0 && v2 === "0") ||
    (v1 === "0" && v2 === 0) || 
    (v1 === 0 && v2 !== 0) ||
    (v1 === "0" && v2 !== "0") ||
    (v1 === 0 && v2 !== "0") ||
    (v1 === "0" && v2 !== 0)))
    {
      return (100).toFixed(2);
    }
      else if(divide === 2 && ((v1 === 0 && v2 !== 0) ||
      (v1 === "0" && v2 !== "0") ||
      (v1 === 0 && v2 !== "0") ||
      (v1 === "0" && v2 !== 0)))
    {
      return (100).toFixed(2);
    }
      else if(divide === 3 && ((v1 === 0 && v2 === 0) ||
      (v1 === "0" && v2 === "0") ||
      (v1 === 0 && v2 === "0") ||
      (v1 === "0" && v2 === 0) || 
      (v1 === 0 && v2 !== 0) ||
      (v1 === "0" && v2 !== "0") ||
      (v1 === 0 && v2 !== "0") ||
      (v1 === "0" && v2 !== 0)))
    {
      return (0).toFixed(2);
    }
      else if(divide === 4 && ((v1 === 0 && v2 !== 0) ||
      (v1 === "0" && v2 !== "0") ||
      (v1 === 0 && v2 !== "0") ||
      (v1 === "0" && v2 !== 0)))
    {
      return (0).toFixed(2);
    }
     else if (v2 === "0" || v2 === 0) {
      return (0).toFixed(2);
     }
     else if (unit === 1 && v1 !== 0 && v2 !== 0) {
      return ((v1 / v2) * 100).toFixed(2);
    } else if (unit === 3 && v1 !== 0 && v2 !== 0) {
      return (((m2Value1 - m2Value2) / m2Value1) * 100).toFixed(2);
    }
  };

  const handleResponsible = (_val) => {
    setResponsibleL(_val);
    //console.log(responsibleL);
  };

  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              {!showAdd && (
                <h4 className={classes.cardTitleWhite}>แก้ไขตัวชี้วัด</h4>
              )}
              {showAdd && (
                <h4 className={classes.cardTitleWhite}>เพิ่มตัวชี้วัด</h4>
              )}
              <p className={classes.cardCategoryWhite}>
                โปรดเลือกหน่วยงานและตัวชี้วัดหรือเพิ่มตัวชี้วัดใหม่
              </p>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={999}
                    options={l1Option}
                    onChange={e => setOption1(e)}
                    clear={checkDefault()}
                    defaulfAdd={isCheck8()}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TSSelect
                    zIndex={998}
                    options={l2Option}
                    onChange={e => setOption2(e)}
                    clear={checkDefault()}
                    disabled={disable1}
                    defaulfAdd={isCheck()}
                  />
                </GridItem>
              </GridContainer>
              <div style={{ paddingTop: "10px" }}></div>
              <GridContainer>
                <GridItem xs={7} sm={9} md={9}>
                  <TSSelect
                    zIndex={997}
                    options={l3Option}
                    onChange={e => setOption3(e)}
                    clear={checkDefault()}
                    disabled={
                      disable2 || (showAdd && (option1 !== 1 && option1 !== 4))
                    }
                    defaulfAdd={isCheck2()}
                    defaulfAdd2={isCheck3()}
                  />
                </GridItem>
                <GridItem xs={5} sm={3} md={3} style={{ height: "48px" }}>
                  <div style={{ textAlign: "center", overflow: "overlay" }}>
                    <Button color="info" onClick={() => setBoth()}>
                      <h4>เพิ่มตัวชี้วัด</h4>
                    </Button>
                  </div>
                </GridItem>
              </GridContainer>
              {(option1 === 1 || option1 === 4) && (
                <GridContainer>
                  <GridItem xs={7} sm={9} md={9}>
                    <TSSelect
                      zIndex={995}
                      options={l4Option}
                      onChange={e => setOption4(e)}
                      disabled={disable3 || (showAdd && option1 !== 4)}
                      defaulfAdd={isCheck5()}
                      defaulfAdd2={isCheck4()}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <div style={{ paddingTop: "10px" }}></div>
              {option1 === 4 && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={9}>
                    <TSSelect
                      zIndex={994}
                      options={l5Option}
                      onChange={e => setOption5(e)}
                      disabled={disable4 || showAdd}
                      defaulfAdd={isCheck7()}
                      defaulfAdd2={isCheck6()}
                    />
                  </GridItem>
                </GridContainer>
              )}
              <div style={{ paddingTop: "20px" }}></div>
              <Collapse isOpen={isOpen}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="ชื่อตัวชี้วัด"
                      id="name"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setName(e)}
                      value={name}
                      inputProps={{
                        disabled: showAdd ? false : !isResponsible  
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <InputLabel style={{ fontFamily: '"Sarabun", sans-serif' }}>
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "16px",
                          color: "rgb(175, 44, 197)"
                        }}
                      >
                        วัตถุประสงค์
                      </div>
                    </InputLabel>
                    <CustomInput
                      labelText=""
                      id="objective"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 5,
                        disabled: showAdd ? false : !isResponsible  
                      }}
                      onChange={e => setObjective(e)}
                      value={objective}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <InputLabel style={{ fontFamily: '"Sarabun", sans-serif' }}>
                      <div
                        style={{
                          color: "rgb(175, 44, 197)",
                          fontWeight: "bold",
                          fontSize: "16px"
                        }}
                      >
                        คำนิยาม
                      </div>
                    </InputLabel>
                    <CustomInput
                      labelText=""
                      id="definition"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 5,
                        disabled: showAdd ? false : !isResponsible  
                      }}
                      onChange={e => setDefinition(e)}
                      value={definition}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="แหล่งข้อมูล"
                      id="dataSource"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setDataSource(e)}
                      value={dataSource}
                      inputProps={{
                        disabled: showAdd ? false : !isResponsible  
                      }}
                    />
                  </GridItem>
                </GridContainer>
                {/* <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="ผู้รับผิดชอบการรายงาน"
                      id="responsible"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setResponsible(e)}
                      value={responsible}
                      // inputProps={{
                      //   disabled: true
                      // }}
                    />
                  </GridItem>
                </GridContainer> */}
                <GridContainer>
                <GridItem xs={12} sm={12} md={12} style={{ marginBottom: "37px" }}>
                    <TreeView  className={classes2.root}
                      defaultExpanded={['3']}
                      defaultCollapseIcon={<ArrowDropDownIcon />}
                      defaultExpandIcon={<ArrowRightIcon />}
                      defaultEndIcon={<div style={{ width: 24 }} />}>
                        <StyledTreeItem nodeId="1" labelText="ผู้รับผิดชอบ" labelIcon={PeopleIcon}>
                          <TSUser value={responsibleL} isMultiple={true} isClear={isClear} onChange={e => { handleResponsible(e) } } />
                        </StyledTreeItem>
                    </TreeView>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="ผู้ให้ข้อมูล"
                      id="informant"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setInformant(e)}
                      value={informant}
                      inputProps={{
                        disabled: showAdd ? false : !isResponsible  
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "37px" }}
                    xs={12}
                    sm={12}
                    md={4}
                  >
                    <TSSelect
                      zIndex={999}
                      options={typeOption}
                      onChange={e => setType(e)}
                      defaulfAdd={defaultType()}
                      clear={checkDefault(1)}
                      disabled={
                        showAdd ? false : !isResponsible  
                      }
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={4}>
                    <CustomInput
                      labelText="ค่าเป้าหมาย"
                      id="target"
                      formControlProps={{
                        fullWidth: true
                      }}
                      onChange={e => setTarget(e)}
                      value={target}
                      numericInput={true}
                      inputProps={{
                        disabled: showAdd ? false : !isResponsible  
                      }}
                    />
                  </GridItem>
                  <GridItem
                    style={{ marginTop: "37px" }}
                    xs={12}
                    sm={12}
                    md={4}
                  >
                    <TSSelect
                      zIndex={998}
                      options={unitOption}
                      onChange={e => setUnit(e)}
                      defaulfAdd={defaultUnit()}
                      clear={checkDefault(2)}
                      disabled={
                        showAdd ? false : !isResponsible  
                      }
                    />
                  </GridItem>
                </GridContainer>
                {/* <GridContainer>
                  {(unit === 1 || unit === 2 || unit === 3 || unit === 4) && (
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="รายการข้อมูล 1"
                        id="data1"
                        formControlProps={{
                          fullWidth: true
                        }}
                        onChange={e => setData1(e)}
                        value={data1}
                        // inputProps={{
                        //   disabled: true
                        // }}
                      />
                    </GridItem>
                  )}
                  {(unit === 1 || unit ===3) && (
                    <GridItem xs={12} sm={12} md={6}>
                      <CustomInput
                        labelText="รายการข้อมูล 2"
                        id="data2"
                        formControlProps={{
                          fullWidth: true
                        }}
                        onChange={e => setData2(e)}
                        value={data2}
                        // inputProps={{
                        //   disabled: true
                        // }}
                      />
                    </GridItem>
                  )}
                </GridContainer> */}
                <GridContainer>
                  <GridItem
                    style={{ marginTop: "37px" }}
                    xs={12}
                    sm={12}
                    md={6}
                  >
                    <TSSelect
                      zIndex={990}
                      options={showOption}
                      onChange={e => setShow(e)}
                      defaulfAdd={defaultShow()}
                      clear={checkDefault(3)}
                      disabled={
                        showAdd ? false : !isResponsible  
                      }
                    />
                  </GridItem>
                  <GridItem
                    style={{ marginTop: "37px" }}
                    xs={12}
                    sm={12}
                    md={6}
                  >
                    <TSSelect
                      zIndex={989}
                      options={frequencyOption}
                      onChange={e => setFrequency(e)}
                      defaulfAdd={defaultFrequency()}
                      clear={checkDefault(4)}
                      disabled={
                        showAdd ? false : !isResponsible  
                      }
                    />
                  </GridItem>
                  {unit === 1 && (
                      <GridItem xs={12} sm={12} md={6}
                      style={{ marginTop: "37px" }}>
                        <TSSelect
                          options={optionsDivide}
                          zIndex={988}
                          onChange={e => setDivide(e)}
                          defaulfAdd={defaultDivide()}
                          disabled={
                            showAdd ? false : !isResponsible  
                          }
                        />
                      </GridItem>
                    )}
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}></GridItem>
                </GridContainer>
              </Collapse>
            </CardBody>
            <CardFooter>
              <Collapse isOpen={isOpen}>
                {showAdd && (
                  <Button color="primary" onClick={handleSubmit}>
                    <h4>Create Data</h4>
                  </Button>
                )}
                {!showAdd && (isResponsible || currentUser.userName == "madarakung" || currentUser.userName == "jamlong" || currentUser.userName == "jatuporn") && (
                  <Button color="primary" onClick={handleSubmit}>
                    <h4>Update Data</h4>
                  </Button>
                )}
                {!showAdd && isResponsible && (
                  <Button color="danger" onClick={onDelete}>
                    <h4>Delete Data</h4>
                  </Button>
                )}
                {!showAdd && isEnabled && isResponsible && (
                  <Button color="warning" onClick={handleEnabled}>
                    <h4>Disable</h4>
                  </Button>
                )}
                {!showAdd && !isEnabled && isResponsible && (
                  <Button color="success" onClick={handleEnabled}>
                    <h4>Enabled</h4>
                  </Button>
                )}
              </Collapse>
              {/* Confirm */}
              <Modal toggle={() => setModal(false)} isOpen={modal}>
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className={icon}
                      style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <p
                    style={{
                      textAlign: "center"
                    }}
                  >
                    {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                      ? "ยืนยันการบันทึกข้อมูล"
                      : "กำลังตรวจสอบข้อมูล"}
                  </p>
                  <p> </p>
                </ModalBody>
                <div className="modal-footer">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModal(false)}
                  >
                    <h4>ยกเลิก</h4>
                  </Button>

                  <Button
                    color="primary"
                    type="button"
                    onClick={handleConfirm}
                    disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                  >
                    <h4>ยืนยัน</h4>
                  </Button>
                </div>
              </Modal>

              <Modal toggle={() => setModal3(false)} isOpen={modal3}>
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className={icon}
                      style={{ color: "blue", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <p
                    style={{
                      textAlign: "center"
                    }}
                  >
                    {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                      ? "ยืนยันการบันทึกข้อมูล"
                      : "กำลังตรวจสอบข้อมูล"}
                  </p>
                  <p> </p>
                </ModalBody>
                <div className="modal-footer">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModal3(false)}
                  >
                    <h4>ยกเลิก</h4>
                  </Button>

                  <Button
                    color="primary"
                    type="button"
                    onClick={handleConfirmUpdate}
                    disabled={icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"}
                  >
                    <h4>ยืนยัน</h4>
                  </Button>
                </div>
              </Modal>

              {/* Error */}
              <Modal toggle={() => setModalError(false)} isOpen={modalError}>
                <div className="modal-header justify-content-center">
                  <div>
                    <i
                      className="fa fa-times"
                      style={{ color: "red", fontSize: "2em" }}
                    ></i>
                  </div>
                </div>
                <ModalBody>
                  <p>ไม่สามารถบันทึกข้อมูลได้</p>
                  <div>{errMsg}</div>
                </ModalBody>
                <div className="modal-footer justify-content-center">
                  <Button
                    color="primary"
                    type="button"
                    onClick={() => setModalError(false)}
                  >
                    <h4>ตกลง</h4>
                  </Button>
                </div>
              </Modal>
            </CardFooter>
          </Card>
        </GridItem>
        {/* <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <a href="#pablo" onClick={e => e.preventDefault()}>
                <img src={avatar} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
              <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
              <h4 className={classes.cardTitle}>Alec Thompson</h4>
              <p className={classes.description}>
                Don{"'"}t be scared of the truth because we need to restart the
                human foundation in truth And I love you like Kanye loves Kanye
                I love Rick Owens’ bed design but the back is...
              </p>
              <Button color="primary" round>
                Follow
              </Button>
            </CardBody>
          </Card>
        </GridItem> */}
      </GridContainer>
{/* 
      {isOpen && (<div>
      <TreeView  className={classes2.root}
      defaultExpanded={['3']}
      defaultCollapseIcon={<ArrowDropDownIcon />}
      defaultExpandIcon={<ArrowRightIcon />}
      defaultEndIcon={<div style={{ width: 24 }} />}>
      <StyledTreeItem nodeId="1" labelText="Test" labelIcon={MailIcon}>
      <StyledTreeItem nodeId="2" labelText="Test" labelIcon={MailIcon}/>
      <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
      <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>ผู้รับผิดชอบ</h4>
          <p className={classes.cardCategoryWhite}>  </p>
        </CardHeader>
        <CardBody>                          
              <TSUser value={responsibleL} isMultiple={true} isClear={isClear} onChange={e => { handleResponsible(e) } } />
        </CardBody>
        <CardFooter>
          <Collapse isOpen={isOpen}>
          </Collapse> */}
            {/* Confirm */}
        {/* </CardFooter>
      </Card>
      </GridItem>
      </GridContainer>
      </StyledTreeItem>
      </TreeView>
    </div>
    )} */}

      {showMonth && (
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>
                    เพิ่มและแก้ไขข้อมูล
                  </h4>
                  <p className={classes.cardCategoryWhite}>กรุณากรอกข้อมูล</p>
                </CardHeader>
                <CardBody>
                  <GridContainer>
                    <GridItem
                      // eslint-disable-next-line no-constant-condition
                      style={1 === 1 ? { marginBottom: "10px" } : {}}
                      xs={12}
                      sm={6}
                      md={6}
                    >
                      <TSSelect
                        options={optionsYear}
                        zIndex={999}
                        onChange={e => setYear(e)}
                        default={optionsYear[0]}
                        defaulfAdd={isCheckDataYear()}
                        disabled={showAdd ? false : !isResponsible  }
                      />
                    </GridItem>           
                    <GridItem xs={12} sm={6} md={6}>
                      <TSSelect
                        options={optionsDataGroup}
                        zIndex={998}
                        disabled={disableGroup || showAdd ? false : !isResponsible  }
                        onChange={e => setDataGroup(e)}
                        defaulfAdd={isCheckDataGroup()}
                        year={year}
                      />
                    </GridItem> 
                  </GridContainer>
                  <div ref={myRef}></div>
                  {(unit === 1 || unit === 3) && (
                    <div>
                      {1 === 1 && (
                        <div>
                          <GridContainer>
                            <GridItem
                              xs={12}
                              sm={12}
                              md={12}
                              style={{ marginTop: "10px" }}
                            >
                              <CustomInput
                                labelText="ชื่อชุดข้อมูล"
                                id="groupName"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                onChange={e => setGroupName(e)}
                                value={groupName}
                                inputProps={{
                                  disabled: showAdd ? false : !isResponsible  
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </div>
                      )}
                      {1 === 1 && (
                        <div>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="รายการข้อมูล 1"
                                id="data1"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                onChange={e => setData1(e)}
                                value={data1}
                                inputProps={{
                                  disabled: showAdd ? false : !isResponsible  
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="รายการข้อมูล 2"
                                id="data2"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                onChange={e => setData2(e)}
                                value={data2}
                                inputProps={{
                                  disabled: showAdd ? false : !isResponsible  
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </div>
                      )}
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>เดือนตุลาคม</h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="october1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM1Value1(e)}
                              value={m1Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="october2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM1Value2(e)}
                              value={m1Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 1 ||
                                (isAddGroup && calMonth >= 1) || (year === '' ? calYear : year) < calYear)  && (
                                <Checkbox
                                  checked={m1Approve}
                                  onClick={event => {
                                    handleClick(event, 1);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 1 ||
                                (isAddGroup && calMonth >= 1) || (year === '' ? calYear : year) < calYear) &&
                              m1Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 1 ||
                                (isAddGroup && calMonth >= 1) || (year === '' ? calYear : year) < calYear) &&
                              !m1Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m1Value1 !== "" &&
                            (m1Value2 !== "" && m1Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal1"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m1Value1, m1Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="octoberTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM1Target(e)}
                              value={m1Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m1Value1 !== "" &&
                            (m1Value2 !== "" && m1Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m1Value1 !== "" &&
                            (m1Value2 !== "" && m1Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="octoberLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM1Link(e)}
                                  value={m1Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>
                              เดือนพฤศจิกายน
                            </h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="november1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM2Value1(e)}
                              value={m2Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="november2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM2Value2(e)}
                              value={m2Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 2 ||
                                (isAddGroup && calMonth >= 2) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m2Approve}
                                  onClick={event => {
                                    handleClick(event, 2);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 2 ||
                                (isAddGroup && calMonth >= 2) || (year === '' ? calYear : year) < calYear) &&
                              m2Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 2 ||
                                (isAddGroup && calMonth >= 2) || (year === '' ? calYear : year) < calYear) &&
                              !m2Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m2Value1 !== "" &&
                            (m2Value2 !== "" && m2Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal2"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m2Value1, m2Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="novemberTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM2Target(e)}
                              value={m2Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m2Value1 !== "" &&
                            (m2Value2 !== "" && m2Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m2Value1 !== "" &&
                            (m2Value2 !== "" && m2Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="novemberLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM2Link(e)}
                                  value={m2Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>เดือนธันวาคม</h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="december1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM3Value1(e)}
                              value={m3Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="december2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM3Value2(e)}
                              value={m3Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 3 ||
                                (isAddGroup && calMonth >= 3) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m3Approve}
                                  onClick={event => {
                                    handleClick(event, 3);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 3 ||
                                (isAddGroup && calMonth >= 3) || (year === '' ? calYear : year) < calYear) &&
                              m3Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 3 ||
                                (isAddGroup && calMonth >= 3) || (year === '' ? calYear : year) < calYear) &&
                              !m3Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m3Value1 !== "" &&
                            (m3Value2 !== "" && m3Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal3"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m3Value1, m3Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="decemberTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM3Target(e)}
                              value={m3Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m3Value1 !== "" &&
                            (m3Value2 !== "" && m3Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m3Value1 !== "" &&
                            (m3Value2 !== "" && m3Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="decemberLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM3Link(e)}
                                  value={m3Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>เดือนมกราคม</h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="่january1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM4Value1(e)}
                              value={m4Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="่january2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM4Value2(e)}
                              value={m4Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 4 ||
                                (isAddGroup && calMonth >= 4) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m4Approve}
                                  onClick={event => {
                                    handleClick(event, 4);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 4 ||
                                (isAddGroup && calMonth >= 4) || (year === '' ? calYear : year) < calYear) &&
                              m4Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 4 ||
                                (isAddGroup && calMonth >= 4) || (year === '' ? calYear : year) < calYear) &&
                              !m4Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m4Value1 !== "" &&
                            (m4Value2 !== "" && m4Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal4"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m4Value1, m4Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="januaryTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM4Target(e)}
                              value={m4Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m4Value1 !== "" &&
                            (m4Value2 !== "" && m4Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m4Value1 !== "" &&
                            (m4Value2 !== "" && m4Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="januaryLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM4Link(e)}
                                  value={m4Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>
                              เดือนกุมภาพันธ์
                            </h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="่february1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM5Value1(e)}
                              value={m5Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="่february2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM5Value2(e)}
                              value={m5Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 5 ||
                                (isAddGroup && calMonth >= 5) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m5Approve}
                                  onClick={event => {
                                    handleClick(event, 5);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 5 ||
                                (isAddGroup && calMonth >= 5) || (year === '' ? calYear : year) < calYear) &&
                              m5Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 5 ||
                                (isAddGroup && calMonth >= 5) || (year === '' ? calYear : year) < calYear) &&
                              !m5Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m5Value1 !== "" &&
                            (m5Value2 !== "" && m5Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal5"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m5Value1, m5Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="februaryTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM5Target(e)}
                              value={m5Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m5Value1 !== "" &&
                            (m5Value2 !== "" && m5Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m5Value1 !== "" &&
                            (m5Value2 !== "" && m5Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="februaryLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM5Link(e)}
                                  value={m5Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>เดือนมีนาคม</h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="่march1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM6Value1(e)}
                              value={m6Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="่march2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM6Value2(e)}
                              value={m6Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 6 ||
                                (isAddGroup && calMonth >= 6) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m6Approve}
                                  onClick={event => {
                                    handleClick(event, 6);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 6 ||
                                (isAddGroup && calMonth >= 6) || (year === '' ? calYear : year) < calYear) &&
                              m6Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 6 ||
                                (isAddGroup && calMonth >= 6) || (year === '' ? calYear : year) < calYear) &&
                              !m6Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m6Value1 !== "" &&
                            (m6Value2 !== "" && m6Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal6"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m6Value1, m6Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="marchTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM6Target(e)}
                              value={m6Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m6Value1 !== "" &&
                            (m6Value2 !== "" && m6Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m6Value1 !== "" &&
                            (m6Value2 !== "" && m6Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="marchLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM6Link(e)}
                                  value={m6Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>เดือนเมษายน</h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="april1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM7Value1(e)}
                              value={m7Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="april2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM7Value2(e)}
                              value={m7Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 7 ||
                                (isAddGroup && calMonth >= 7) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m7Approve}
                                  onClick={event => {
                                    handleClick(event, 7);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 7 ||
                                (isAddGroup && calMonth >= 7) || (year === '' ? calYear : year) < calYear) &&
                              m7Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 7 ||
                                (isAddGroup && calMonth >= 7) || (year === '' ? calYear : year) < calYear) &&
                              !m7Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m7Value1 !== "" &&
                            (m7Value2 !== "" && m7Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal7"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m7Value1, m7Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="aprilTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM7Target(e)}
                              value={m7Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m7Value1 !== "" &&
                            (m7Value2 !== "" && m7Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m7Value1 !== "" &&
                            (m7Value2 !== "" && m7Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="aprilLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM7Link(e)}
                                  value={m7Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>เดือนพฤษภาคม</h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="may1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM8Value1(e)}
                              value={m8Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="may2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM8Value2(e)}
                              value={m8Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 8 ||
                                (isAddGroup && calMonth >= 8) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m8Approve}
                                  onClick={event => {
                                    handleClick(event, 8);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 8 ||
                                (isAddGroup && calMonth >= 8) || (year === '' ? calYear : year) < calYear) &&
                              m8Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 8 ||
                                (isAddGroup && calMonth >= 8) || (year === '' ? calYear : year) < calYear) &&
                              !m8Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m8Value1 !== "" &&
                            (m8Value2 !== "" && m8Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal8"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m8Value1, m8Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="mayTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM8Target(e)}
                              value={m8Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m8Value1 !== "" &&
                            (m8Value2 !== "" && m8Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m8Value1 !== "" &&
                            (m8Value2 !== "" && m8Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="mayLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM8Link(e)}
                                  value={m8Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>
                              เดือนมิถุนายน
                            </h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="june1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM9Value1(e)}
                              value={m9Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="june2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM9Value2(e)}
                              value={m9Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 9 ||
                                (isAddGroup && calMonth >= 9) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m9Approve}
                                  onClick={event => {
                                    handleClick(event, 9);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 9 ||
                                (isAddGroup && calMonth >= 9) || (year === '' ? calYear : year) < calYear) &&
                              m9Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 9 ||
                                (isAddGroup && calMonth >= 9) || (year === '' ? calYear : year) < calYear) &&
                              !m9Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m9Value1 !== "" &&
                            (m9Value2 !== "" && m9Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal9"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m9Value1, m9Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="juneTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM9Target(e)}
                              value={m9Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m9Value1 !== "" &&
                            (m9Value2 !== "" && m9Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m9Value1 !== "" &&
                            (m9Value2 !== "" && m9Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="juneLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM9Link(e)}
                                  value={m9Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>เดือนกรกฎาคม</h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="july1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM10Value1(e)}
                              value={m10Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="july2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM10Value2(e)}
                              value={m10Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 10 ||
                                (isAddGroup && calMonth >= 10) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m10Approve}
                                  onClick={event => {
                                    handleClick(event, 10);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 10 ||
                                (isAddGroup && calMonth >= 10) || (year === '' ? calYear : year) < calYear) &&
                              m10Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 10 ||
                                (isAddGroup && calMonth >= 10) || (year === '' ? calYear : year) < calYear) &&
                              !m10Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m10Value1 !== "" &&
                            (m10Value2 !== "" && m10Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal10"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m10Value1, m10Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="julyTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM10Target(e)}
                              value={m10Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m10Value1 !== "" &&
                            (m10Value2 !== "" && m10Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m10Value1 !== "" &&
                            (m10Value2 !== "" && m10Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="julyLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM10Link(e)}
                                  value={m10Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        {" "}
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>เดือนสิงหาคม</h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="august1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM11Value1(e)}
                              value={m11Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="august2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM11Value2(e)}
                              value={m11Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 11 ||
                                (isAddGroup && calMonth >= 11) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m11Approve}
                                  onClick={event => {
                                    handleClick(event, 11);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 11 ||
                                (isAddGroup && calMonth >= 11) || (year === '' ? calYear : year) < calYear) &&
                              m11Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 11 ||
                                (isAddGroup && calMonth >= 11) || (year === '' ? calYear : year) < calYear) &&
                              !m11Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m11Value1 !== "" &&
                            (m11Value2 !== "" && m11Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal11"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m11Value1, m11Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="augustTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM11Target(e)}
                              value={m11Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m11Value1 !== "" &&
                            (m11Value2 !== "" && m11Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m11Value1 !== "" &&
                            (m11Value2 !== "" && m11Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="augustLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM11Link(e)}
                                  value={m11Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                      <div
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridContainer>
                          <GridItem
                            style={{ marginTop: "37px" }}
                            xs={12}
                            sm={12}
                            md={2}
                          >
                            <h4 className={classes.CardHeader}>เดือนกันยายน</h4>
                          </GridItem>
                          <GridItem
                            xs={12}
                            sm={12}
                            md={10}
                            style={{ marginTop: "37px" }}
                          >
                            <CustomInput
                              labelText={data1}
                              id="september1"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM12Value1(e)}
                              value={m12Value1}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem xs={0} sm={0} md={2}></GridItem>
                          <GridItem xs={12} sm={12} md={10}>
                            <CustomInput
                              labelText={data2}
                              id="september2"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM12Value2(e)}
                              value={m12Value2}
                              numericInput={true}
                            />
                          </GridItem>
                        </GridContainer>
                        <GridContainer>
                          <GridItem
                            xs={4}
                            sm={2}
                            md={2}
                            style={{ textAlign: "center", marginTop: "43px" }}
                          >
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 12 ||
                                (isAddGroup && calMonth >= 12) || (year === '' ? calYear : year) < calYear) && (
                                <Checkbox
                                  checked={m12Approve}
                                  onClick={event => {
                                    handleClick(event, 12);
                                  }}
                                  disabled = {showAdd ? false : !isResponsible  }
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 12 ||
                                (isAddGroup && calMonth >= 12) || (year === '' ? calYear : year) < calYear) &&
                              m12Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={approved}
                                  alt="..."
                                />
                              )}
                            {(frequency === 1 ||
                              frequency === 2 ||
                              frequency === 3 ||
                              frequency === 4) &&
                              (calMonth >= 12 ||
                                (isAddGroup && calMonth >= 12) || (year === '' ? calYear : year) < calYear) &&
                              !m12Approve && (
                                <img
                                  style={{ width: "40%" }}
                                  src={rejected}
                                  alt="..."
                                />
                              )}
                          </GridItem>
                          {m12Value1 !== "" &&
                            (m12Value2 !== "" && m12Value2 !== null) && (
                              <GridItem xs={4} sm={5} md={5}>
                                <CustomInput
                                  labelText="ผลคำนวน"
                                  id="cal12"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: true
                                  }}
                                  value={getCalM(m12Value1, m12Value2, divide)}
                                />
                              </GridItem>
                            )}
                          <GridItem xs={4} sm={5} md={5}>
                            <CustomInput
                              labelText={"ค่าเป้าหมาย"}
                              id="septemberTarget"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                disabled: showAdd ? false : !isResponsible  
                              }}
                              onChange={e => setM12Target(e)}
                              value={m12Target}
                              numericInput={true}
                            />
                          </GridItem>
                          {m12Value1 !== "" &&
                            (m12Value2 !== "" && m12Value2 !== null) && (
                              <GridItem xs={4} sm={2} md={2}>
                                <div></div>
                              </GridItem>
                            )}
                          {m12Value1 !== "" &&
                            (m12Value2 !== "" && m12Value2 !== null) && (
                              <GridItem xs={8} sm={10} md={10}>
                                <CustomInput
                                  labelText={"Link"}
                                  id="septemberLink"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    disabled: showAdd ? false : !isResponsible  
                                  }}
                                  onChange={e => setM12Link(e)}
                                  value={m12Link}
                                />
                              </GridItem>
                            )}
                        </GridContainer>
                      </div>
                    </div>
                  )}

                  {(unit === 2 || unit === 4) && (
                    <div>
                      {1 === 1 && (
                        <div>
                          <GridContainer>
                            <GridItem
                              xs={12}
                              sm={12}
                              md={12}
                              style={{ marginTop: "10px" }}
                            >
                              <CustomInput
                                labelText="ชื่อชุดข้อมูล"
                                id="groupName"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                onChange={e => setGroupName(e)}
                                value={groupName}
                                inputProps={{
                                  disabled: showAdd ? false : !isResponsible  
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </div>
                      )}
                      {1 === 1 && (
                        <div>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="รายการข้อมูล 1"
                                id="data1"
                                formControlProps={{
                                  fullWidth: true
                                }}
                                onChange={e => setData1(e)}
                                value={data1}
                                inputProps={{
                                  disabled: showAdd ? false : !isResponsible  
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                        </div>
                      )}
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          xs={12}
                          sm={12}
                          md={2}
                          style={{ marginTop: "37px" }}
                        >
                          <h4 className={classes.CardHeader}>เดือนตุลาคม</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="october"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM1Value1(e)}
                            value={m1Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 1 ||
                              (isAddGroup && calMonth >= 1) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m1Approve}
                                onClick={event => {
                                  handleClick(event, 1);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 1 || (isAddGroup && calMonth >= 1 ) || (year === '' ? calYear : year) < calYear) &&
                            m1Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 1 || (isAddGroup && calMonth >= 1) || (year === '' ? calYear : year) < calYear) &&
                            !m1Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="octoberTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM1Target(e)}
                            value={m1Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText="Link"
                            id="octoberLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM1Link(e)}
                            value={m1Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนพฤศจิกายน</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="november"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM2Value1(e)}
                            value={m2Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 2 ||
                              (isAddGroup && calMonth >= 2) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m2Approve}
                                onClick={event => {
                                  handleClick(event, 2);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 2 || (isAddGroup && calMonth >= 2) || (year === '' ? calYear : year) < calYear) &&
                            m2Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 2 || (isAddGroup && calMonth >= 2) || (year === '' ? calYear : year) < calYear) &&
                            !m2Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="novemberTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM2Target(e)}
                            value={m2Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="novemberLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM2Link(e)}
                            value={m2Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนธันวาคม</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="december"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM3Value1(e)}
                            value={m3Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 3 ||
                              (isAddGroup && calMonth >= 3) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m3Approve}
                                onClick={event => {
                                  handleClick(event, 3);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 3 || (isAddGroup && calMonth >= 3) || (year === '' ? calYear : year) < calYear) &&
                            m3Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 3 || (isAddGroup && calMonth >= 3) || (year === '' ? calYear : year) < calYear) &&
                            !m3Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="decemberTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM3Target(e)}
                            value={m3Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="decemberLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM3Link(e)}
                            value={m3Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนมกราคม</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="่january"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM4Value1(e)}
                            value={m4Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 4 ||
                              (isAddGroup && calMonth >= 4) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m4Approve}
                                onClick={event => {
                                  handleClick(event, 4);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 4 || (isAddGroup && calMonth >= 4) || (year === '' ? calYear : year) < calYear) &&
                            m4Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 4 || (isAddGroup && calMonth >= 4) || (year === '' ? calYear : year) < calYear) &&
                            !m4Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="่januaryTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM4Target(e)}
                            value={m4Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="januaryLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM4Link(e)}
                            value={m4Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>
                            เดือนกุมภาพันธ์
                          </h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="่february"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM5Value1(e)}
                            value={m5Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 5 ||
                              (isAddGroup && calMonth >= 5) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m5Approve}
                                onClick={event => {
                                  handleClick(event, 5);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 5 || (isAddGroup && calMonth >= 5) || (year === '' ? calYear : year) < calYear) &&
                            m5Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 5 || (isAddGroup && calMonth >= 5) || (year === '' ? calYear : year) < calYear) &&
                            !m5Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="่februaryTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM5Target(e)}
                            value={m5Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="februaryLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM5Link(e)}
                            value={m5Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนมีนาคม</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="่march"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM6Value1(e)}
                            value={m6Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 6 ||
                              (isAddGroup && calMonth >= 6) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m6Approve}
                                onClick={event => {
                                  handleClick(event, 6);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 6 || (isAddGroup && calMonth >= 6) || (year === '' ? calYear : year) < calYear) &&
                            m6Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 6 || (isAddGroup && calMonth >= 6) || (year === '' ? calYear : year) < calYear) &&
                            !m6Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="marchTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM6Target(e)}
                            value={m6Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="marchLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM6Link(e)}
                            value={m6Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนเมษายน</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="april"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM7Value1(e)}
                            value={m7Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 7 ||
                              (isAddGroup && calMonth >= 7) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m7Approve}
                                onClick={event => {
                                  handleClick(event, 7);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 7 || (isAddGroup && calMonth >= 7) || (year === '' ? calYear : year) < calYear) &&
                            m7Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 7 || (isAddGroup && calMonth >= 7) || (year === '' ? calYear : year) < calYear) &&
                            !m7Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="aprilTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM7Target(e)}
                            value={m7Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="aprilLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM7Link(e)}
                            value={m7Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนพฤษภาคม</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="may"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM8Value1(e)}
                            value={m8Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 8 ||
                              (isAddGroup && calMonth >= 8) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m8Approve}
                                onClick={event => {
                                  handleClick(event, 8);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 8 || (isAddGroup && calMonth >= 8) || (year === '' ? calYear : year) < calYear) &&
                            m8Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 8 || (isAddGroup && calMonth >= 8) || (year === '' ? calYear : year) < calYear) &&
                            !m8Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="่mayTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM8Target(e)}
                            value={m8Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="mayLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM8Link(e)}
                            value={m8Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนมิถุนายน</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="june"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM9Value1(e)}
                            value={m9Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 9 ||
                              (isAddGroup && calMonth >= 9) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m9Approve}
                                onClick={event => {
                                  handleClick(event, 9);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 9 || (isAddGroup && calMonth >= 9) || (year === '' ? calYear : year) < calYear) &&
                            m9Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 9 || (isAddGroup && calMonth >= 9) || (year === '' ? calYear : year) < calYear) &&
                            !m9Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="่juneTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM9Target(e)}
                            value={m9Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="่juneLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM9Link(e)}
                            value={m9Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนกรกฎาคม</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="july"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM10Value1(e)}
                            value={m10Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 10 ||
                              (isAddGroup && calMonth >= 10) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m10Approve}
                                onClick={event => {
                                  handleClick(event, 10);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 10 ||
                              (isAddGroup && calMonth >= 10) || (year === '' ? calYear : year) < calYear) &&
                            m10Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 10 ||
                              (isAddGroup && calMonth >= 10) || (year === '' ? calYear : year) < calYear) &&
                            !m10Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="julyget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM10Target(e)}
                            value={m10Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="่juneLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM10Link(e)}
                            value={m10Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนสิงหาคม</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="august"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM11Value1(e)}
                            value={m11Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 11 ||
                              (isAddGroup && calMonth >= 11) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m11Approve}
                                onClick={event => {
                                  handleClick(event, 11);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 11 ||
                              (isAddGroup && calMonth >= 11) || (year === '' ? calYear : year) < calYear) &&
                            m11Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 11 ||
                              (isAddGroup && calMonth >= 11) || (year === '' ? calYear : year) < calYear) &&
                            !m11Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="augustTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM11Target(e)}
                            value={m11Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="่augustLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM11Link(e)}
                            value={m11Link}
                          />
                        </GridItem>
                      </GridContainer>
                      <GridContainer
                        style={{
                          border: "solid 1px",
                          color: primaryColor,
                          borderRadius: "50px"
                        }}
                      >
                        <GridItem
                          style={{ marginTop: "37px" }}
                          xs={12}
                          sm={12}
                          md={2}
                        >
                          <h4 className={classes.CardHeader}>เดือนกันยายน</h4>
                        </GridItem>
                        <GridItem
                          xs={12}
                          sm={12}
                          md={10}
                          style={{ marginTop: "37px" }}
                        >
                          <CustomInput
                            labelText={data1}
                            id="september"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM12Value1(e)}
                            value={m12Value1}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem
                          xs={4}
                          sm={2}
                          md={2}
                          style={{ textAlign: "center", marginTop: "43px" }}
                        >
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 12 ||
                              (isAddGroup && calMonth >= 12) || (year === '' ? calYear : year) < calYear) && (
                              <Checkbox
                                checked={m12Approve}
                                onClick={event => {
                                  handleClick(event, 12);
                                }}
                                disabled = {showAdd ? false : !isResponsible  }
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 12 ||
                              (isAddGroup && calMonth >= 12) || (year === '' ? calYear : year) < calYear) &&
                            m12Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={approved}
                                alt="..."
                              />
                            )}
                          {(frequency === 1 ||
                            frequency === 2 ||
                            frequency === 3 ||
                            frequency === 4) &&
                            (calMonth >= 12 ||
                              (isAddGroup && calMonth >= 12) || (year === '' ? calYear : year) < calYear) &&
                            !m12Approve && (
                              <img
                                style={{ width: "40%" }}
                                src={rejected}
                                alt="..."
                              />
                            )}
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"ค่าเป้าหมาย"}
                            id="่septemberTarget"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM12Target(e)}
                            value={m12Target}
                            numericInput={true}
                          />
                        </GridItem>
                        <GridItem xs={4} sm={2} md={2}>
                          <div></div>
                        </GridItem>
                        <GridItem xs={8} sm={10} md={10}>
                          <CustomInput
                            labelText={"Link"}
                            id="่septemLink"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              disabled: showAdd ? false : !isResponsible  
                            }}
                            onChange={e => setM12Link(e)}
                            value={m12Link}
                          />
                        </GridItem>
                      </GridContainer>
                    </div>
                  )}
                </CardBody>
                <CardFooter>
                { isResponsible && (
                  <div>
                    {(!addMonth || isAddGroup) && (
                      <Button color="primary" onClick={handleSubmitMonth}>
                        <h4>Create Data</h4>
                      </Button>
                    )}
                    {addMonth && !isAddGroup && (
                      <Button color="primary" onClick={handleSubmitMonthUpdate}>
                        <h4>Update Data</h4>
                      </Button>
                    )}
                  </div>
                  )}
                  { isResponsible && (
                  <div style={{ textAlign: "center", overflow: "overlay" }}>
                    {!isAddGroup && (
                      <Button color="info" onClick={() => setBoth2()}>
                        <h4>เพิ่มชุดข้อมูล</h4>
                      </Button>
                    )}
                    {!isAddGroup && (
                      <Button color="danger" onClick={onDelete2}>
                        <h4>ลบชุดข้อมูล</h4>
                      </Button>
                    )}
                    {isAddGroup && (
                      <Button color="info" onClick={() => setBoth3()}>
                        <h4>ยกเลิก</h4>
                      </Button>
                    )}
                  </div>
                  )}
                  {/* Confirm */}
                  <Modal toggle={() => setModal2(false)} isOpen={modal2}>
                    <div className="modal-header justify-content-center">
                      <div>
                        <i
                          className={icon2}
                          style={{ color: "blue", fontSize: "2em" }}
                        ></i>
                      </div>
                    </div>
                    <ModalBody>
                      <p
                        style={{
                          textAlign: "center"
                        }}
                      >
                        {icon2 !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                          ? "ยืนยันการบันทึกข้อมูล"
                          : "กำลังตรวจสอบข้อมูล"}
                      </p>
                      <p> </p>
                    </ModalBody>
                    <div className="modal-footer">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => setModal2(false)}
                      >
                        <h4>ยกเลิก</h4>
                      </Button>

                      <Button
                        color="primary"
                        type="button"
                        onClick={handleConfirmMonth}
                        disabled={
                          icon2 === "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        }
                      >
                        <h4>ยืนยัน</h4>
                      </Button>
                    </div>
                  </Modal>
                  <Modal toggle={() => setModal4(false)} isOpen={modal4}>
                    <div className="modal-header justify-content-center">
                      <div>
                        <i
                          className={icon2}
                          style={{ color: "blue", fontSize: "2em" }}
                        ></i>
                      </div>
                    </div>
                    <ModalBody>
                      <p
                        style={{
                          textAlign: "center"
                        }}
                      >
                        {icon2 !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                          ? "ยืนยันการบันทึกข้อมูล"
                          : "กำลังตรวจสอบข้อมูล"}
                      </p>
                      <p> </p>
                    </ModalBody>
                    <div className="modal-footer">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => setModal4(false)}
                      >
                        <h4>ยกเลิก</h4>
                      </Button>

                      <Button
                        color="primary"
                        type="button"
                        onClick={handleConfirmMonthUpdate}
                        disabled={
                          icon2 === "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        }
                      >
                        <h4>ยืนยัน</h4>
                      </Button>
                    </div>
                  </Modal>

                  <Modal
                    toggle={() => setModalDelete(false)}
                    isOpen={modalDelete}
                  >
                    <div className="modal-header justify-content-center">
                      <div>
                        <i
                          className={icon}
                          style={{ color: "blue", fontSize: "2em" }}
                        ></i>
                      </div>
                    </div>
                    <ModalBody>
                      <p
                        style={{
                          textAlign: "center"
                        }}
                      >
                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                          ? "ยืนยันการลบข้อมูล"
                          : "กำลังตรวจสอบข้อมูล"}
                      </p>
                      <p> </p>
                    </ModalBody>
                    <div className="modal-footer">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => setModalDelete(false)}
                      >
                        <h4>ยกเลิก</h4>
                      </Button>

                      <Button
                        color="primary"
                        type="button"
                        onClick={handleDelete}
                        disabled={
                          icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        }
                      >
                        <h4>ยืนยัน</h4>
                      </Button>
                    </div>
                  </Modal>

                  <Modal
                    toggle={() => setModalDelete2(false)}
                    isOpen={modalDelete2}
                  >
                    <div className="modal-header justify-content-center">
                      <div>
                        <i
                          className={icon}
                          style={{ color: "blue", fontSize: "2em" }}
                        ></i>
                      </div>
                    </div>
                    <ModalBody>
                      <p
                        style={{
                          textAlign: "center"
                        }}
                      >
                        {icon !== "fa fa-spinner fa-w-16 fa-spin fa-lg"
                          ? "ยืนยันการลบข้อมูล"
                          : "กำลังตรวจสอบข้อมูล"}
                      </p>
                      <p> </p>
                    </ModalBody>
                    <div className="modal-footer">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => setModalDelete2(false)}
                      >
                        <h4>ยกเลิก</h4>
                      </Button>

                      <Button
                        color="primary"
                        type="button"
                        onClick={handleDelete2}
                        disabled={
                          icon === "fa fa-spinner fa-w-16 fa-spin fa-lg"
                        }
                      >
                        <h4>ยืนยัน</h4>
                      </Button>
                    </div>
                  </Modal>

                  {/* Error */}
                  <Modal
                    toggle={() => setModalError(false)}
                    isOpen={modalError}
                  >
                    <div className="modal-header justify-content-center">
                      <div>
                        <i
                          className="fa fa-times"
                          style={{ color: "red", fontSize: "2em" }}
                        ></i>
                      </div>
                    </div>
                    <ModalBody>
                      <p>ไม่สามารถบันทึกข้อมูลได้</p>
                      <div>{errMsg}</div>
                    </ModalBody>
                    <div className="modal-footer justify-content-center">
                      <Button
                        color="primary"
                        type="button"
                        onClick={() => setModalError(false)}
                      >
                        <h4>ตกลง</h4>
                      </Button>
                    </div>
                  </Modal>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      )}
    </div>
  );
}
